import fr from 'facet-rest';
import WizardWelcomeStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardWelcomeStepTemplate';
import BigPickListTemplate from 'Views/Page/Content/Templates/BigPickListTemplate';
import BeneficiaryDetailListTemplate from 'Views/Page/Content/Templates/WizardTemplates/BeneficiaryDetailListTemplate';
import InvestmentObjectivesAccountReviewTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/InvestmentObjectivesAccountReviewTemplate';
import ModuleWelcomeStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/ModuleWelcomeStepTemplate';
import RiskToleranceResultTemplate from 'Views/Page/Content/Templates/WizardTemplates/RiskToleranceResultTemplate';
import RiskToleranceManualTemplate from 'Views/Page/Content/Templates/WizardTemplates/RiskToleranceManualTemplate';
import AnnualInvestmentReviewCompleteTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/AnnualnvestmentReviewCompleteTemplate';
import GenericTableTemplate from 'Views/Page/Content/Templates/GenericTableTemplate';
import WhatIfItemManagementCreationTemplate from 'Views/Page/Content/Templates/WhatIfItemManagementCreationTemplate';
import WhatIfProposalPreviewTemplate from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate';
import SettingsTemplate from 'Views/Page/Content/Templates/SettingsTemplate/Content';
import InvestmentProfileCompleteTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/InvestmentProfileCompleteTemplate';
import SwitchViewTemplate from 'Views/Page/Content/Templates/SwitchViewTemplate';
import GeneratedViewTemplate from 'Views/Page/Content/Templates/GeneratedViewTemplate';
import PlannerTransitionHouseholdTemplate from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate';
import LinkingAttemptsTemplate from 'Views/Page/Content/Templates/LinkingAttemptsTemplate';
import { UpgradeConfirmationPageTemplate } from 'Views/Page/Content/Templates/UpgradeConfirmationPageTemplate';
import { MemberDashboard } from 'Views/Page/Content/Templates/MemberDashboard/MemberDashboard';
import WizardBigHierarchyMultipicklistControl
  from 'Views/Page/Content/Templates/WizardTemplates/WizardBigHierarchyMultipicklistControl';
import ClientScenarioIntroPicker from 'Views/Page/Content/Templates/WizardTemplates/ClientScenarioIntro';
import {
  Layout as ClientScenarioReviewLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ClientScenarioReview';
import NoopPageTemplate from 'Views/Page/Content/Templates/WizardTemplates/NoopTemplate';
import DummyTemplate from 'Views/Page/Content/Templates/WizardTemplates/DummyTemplate';
import WizardAutoComplete from 'Views/Page/Content/Templates/WizardTemplates/WizardAutoComplete';
import WizardAttachmentsTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardAttachmentsTemplate';
import AumHouseholdViewTemplate from 'Views/Page/Content/Templates/AumHouseholdViewTemplate';
import ManagedAccountAllocationCleanup from 'Views/Page/Content/Templates/ManagedAccountAllocationCleanupTemplate';
import EmailVerificationSentStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/Buy/emailVerificationSentStep';
import FacetPlanCongratulationsTemplate from 'Views/Page/Content/Templates/FacetPlanCongratulationsTemplate';
import TaskStatusViewTemplate from 'Views/Page/Content/Templates/TaskStatusViewTemplate';
import WizardBadgeStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardBadgeStepTemplate';
import WizardBadgeBigPickListTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/WizardBadgeBigPickListTemplate';
import WizardMutipleYesNoQuestionsTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/WizardMutipleYesNoQuestionsTemplate';
import AccountRetitlingSuccessTemplate from 'Views/Page/Content/Templates/AccountRetitlingSuccessStep';
import PlannerAccountOpeningModelAssignmentTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningModelAssignmentTemplate/ModelAssignment';
import PlannerAccountOpeningESGConfirmationTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningModelAssignmentTemplate/EsgConfirmation';
import EditFacetPlanTemplate from 'Views/Page/Content/Templates/EditFacetPlanTemplate';
import CIPInformationVerificationTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/CIPInformationVerificationTemplate';
import CIPStatusItemDocumentUploadTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/CIPStatusItemDocumentUpload';
import AccountProposalReviewStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ClientAccountOpening/AccountProposalReviewStepTemplate';
import WizardStepDetailListTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepDetailListTemplate';
import ClientAccountOpeningStartPageTemplate from 'Views/Page/Content/Templates/ClientAccountOpeningStartPageTemplate';
import CIPFinishTemplate from 'Views/Page/Content/Templates/WizardTemplates/CIPFinishTemplate';
import CIPDocumentReviewTemplate from 'Views/Page/Content/Templates/WizardTemplates/CIPDocumentReview';
import ACHTransferSelectAccountTemplate from 'Views/Page/Content/Templates/ACHTransferSelectAccountTemplate';
import SupportTemplate from 'Views/Page/Content/Templates/SupportTemplate/Content';
import ACATInstitutionSelectionTemplate from 'Views/Page/Content/Templates/AcatInstitutionSelectionTemplate';
import HierarchicalViewTemplate from 'Views/Page/Content/Templates/HierarchicalViewTemplate';
import MissionControl from 'Components/AdvisorApp/Viewport/MissionControl/Page';
import FacetPlanAssumptionSetTemplate from 'Views/Page/Content/Templates/FacetPlanAssumptionSetTemplate';
import AcatTransferFundsTemplate from 'Views/Page/Content/Templates/AcatTransferFundsTemplate';
import AccountRolloverWizardStepTemplate
  from 'Views/Page/Content/Templates/AccountRolloverTemplate/AccountRolloverWizardStepTemplate';
import FundingInstructionsPageTemplate from 'Views/Page/Content/Templates/FundingInstructionsPageTemplate';
import TransferCompleteTemplate from 'Views/Page/Content/Templates/TransferCompleteTemplate';
import ACHTransferTemplate from 'Views/Page/Content/Templates/ACHTransferTemplate';
import SelectTransferTypeTemplate from 'Views/Page/Content/Templates/SelectTransferTypeTemplate';
import AccountTransferSetupSelectTransferTypeTemplate
  from 'Views/Page/Content/Templates/AccountTransferSetupSelectTransferTypeTemplate';
import NonAcatConfirmationStepTemplate from 'Views/Page/Content/Templates/NonAcatConfirmationStepTemplate';
import ProfileTemplate from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate';
import AddPaymentMethodProfileSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/AddPaymentMethodProfileSubpage';
import CancelMembershipSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/CancelMembershipSubpage';
import BillingDetailsProfileSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/BillingDetailsProfileSubpage/BillingDetailsProfileSubpage';
import EstatePlanningProfileSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/EstatePlanningProfileSubpage/EstatePlanningProfileSubpage';
import ApexFundingAccountUnlinkTemplate from 'Views/Page/Content/Templates/ApexFundingAccountUnlinkTemplate';
import ApexFundingAccountDeleteTemplate from 'Views/Page/Content/Templates/ApexFundingAccountDeleteTemplate';
import ApexFundingAccountSyncTemplate from 'Views/Page/Content/Templates/ApexFundingAccountSyncTemplate';
import TemporaryPersonalAndFamilySubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/TemporaryPersonalAndFamilySubpage';
import AccountDebitDisclaimerProfileSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/AddPaymentMethodProfileSubpage/AccountDebitDisclaimerProfileSubpage';
import LinkedAccountErrorViewTemplate from 'Views/Page/Content/Templates/LinkedAccountErrorViewTemplate';
import ManagedAccountPageTemplate from 'Views/Page/Content/Templates/ManagedAccountPageTemplate';
import ScheduledCashJournal from 'Views/Page/Content/Templates/ScheduledCashJournal/ScheduledCashJournal';
import ScheduledCashJournalSetup from 'Views/Page/Content/Templates/ScheduledCashJournalSetupStep/ScheduledCashJournalSetupStepTemplate';
import ScheduledCashJournalCompleteStep from 'Views/Page/Content/Templates/ScheduledCashJournalCompleteStep/ScheduledCashJournalCompleteStepTemplate';
import RedirectTemplate from 'Views/Page/Content/Templates/RedirectTemplate';
import SelectInstitutionTemplate from 'Views/Page/Content/Templates/SelectInstitutionTemplate';
import ApexFundingAccountRejectedStepTemplate
  from 'Views/Page/Content/Templates/ApexFundingAccountRejectedStepTemplate/ApexFundingAccountRejectedStepTemplate';
import LinkOrAddAccountsTemplate
  from 'Views/Page/Content/Templates/LinkOrAddAccountsTemplate/LinkOrAddAccountsTemplate';
import FailedToLinkTemplate from 'Views/Page/Content/Templates/FailedToLinkTemplate/FailedToLinkTemplate';
import WhatIfFacetPlanUpdateAccountMappingTemplate
  from 'Views/Page/Content/Templates/WhatIfFacetPlanUpdateAccountMappingTemplate';
import WhatIfFacetPlanUpdateImportAccountsTemplate
  from 'Views/Page/Content/Templates/WhatIfFacetPlanUpdateImportAccountsTemplate';
import WhatIfFacetPlanUpdateVirtualAccountsTemplate
  from 'Views/Page/Content/Templates/WhatIfFacetPlanUpdateVirtualAccountsTemplate';
import InstitutionSuccessRateTemplate from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate';
import FundingInstructionsFundingTypeWizardStep
  from 'Views/Page/Content/Templates/FundingInstructionFundingTypeTemplate/FundingInstructionFundingTypeWizardStep';
import FundingInstructionCompleteTemplate from 'Views/Page/Content/Templates/FundingInstructionCompleteTemplate';
import UploadOrSelectFromSecureFilesTemplate
  from 'Views/Page/Content/Templates/UploadOrSelectFromSecureFilesTemplate/UploadOrSelectFromSecureFilesTemplate';
import UploadFileTemplate from 'Views/Page/Content/Templates/UploadFileTemplate/UploadFileTemplate';
import SelectFileTemplate from 'Views/Page/Content/Templates/SelectFileTemplate/SelectFileTemplate';
import {
  AccountOpeningV2ProposalStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2ProposalStepTemplate';
import { AccountOpeningV2PendingStep } from 'Views/Page/Content/Templates/AccountOpeningV2PendingStep';
import {
  AccountOpeningV2OpeningTakingTooLongStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2OpeningTakingTooLongStepTemplate';
import FacetPlanClientScenarioInsightTemplate
  from 'Views/Page/Content/Templates/FacetPlanClientScenarioInsightTemplate';
import WizardTemplateWithMetaOverride from 'Views/Page/Content/Templates/WizardTemplateWithMetaOverride';
import { ProfilePage } from 'Views/Page/Content/Templates/ProfilePage';
import { ProfilePageMDC } from 'Views/Page/Content/Templates/ProfilePageMDC';
import WizardCompleteStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardCompleteStepTemplate';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import InvestmentProfileClientUncommonSituationsTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/InvestmentProfileClientUncommonSituationsTemplate';
import AccountOpeningAgreementTemplatePicker
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/accountOpeningAgreementTemplatePicker';
import AccountOpeningAgreementV2TemplatePicker
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/accountOpeningAgreementV2TemplatePicker';
import ActivationAccountFundingInstructionsTemplate
  from 'Views/Page/Content/Templates/FundingInstructionsPageTemplate/ActivationAccountFundingInstructions';
import CIPFinishActivationTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ActivationCIPFinishTemplate/CIPFInishActivationTemplate';
import ApexFundingAccountVerificationTemplatePicker
  from 'Views/Page/Content/Templates/ApexFundingAccountVerificationTemplate/apexFundingAccountVerificationTemplatePicker';
import ApexFundingAccountResultTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ApexFundingAccountResultTemplate/ApexFundingAccountResultTemplate';
import ScenarioSelectionScenarioDetailsTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionScenarioDetailsTemplate';
import ScenarioSelectionCommonInsights
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionCommonInsights/ScenarioSelectionCommonInsights';
import ScenarioSelectionViewInsightsStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionViewInsightsStepTemplate';
import ScenarioActivationDeclineConfirmation
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioActivationDeclineConfirmation/ScenarioActivationDeclineConfirmation';
import Scheduler from 'Views/Page/Content/Templates/WizardTemplates/Scheduler/Scheduler';
import ScenarioReselectionStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioReselectionStepTemplate';
import ScenarioActivationQuestionStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioActivationQuestionStepTemplate';
import ScenarioActivationAutomatedTransferScheduledStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioActivationAutomatedTransferScheduledStepTemplate';
import ScenarioActivationAccountOpeningInterstitialTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioActivationAccountOpeningInterstitialTemplate';
import FacetPlanProposalNextUpReviewPageTemplate
  from 'Views/Page/Content/Templates/FacetPlanProposalNextUpReviewPageTemplate';
import FacetPlanProposalScenarioSelectionIntroPageTemplate
  from 'Views/Page/Content/Templates/FacetPlanProposalScenarioSelectionIntroPageTemplate';
import CashAccountProposal from 'Views/Page/Content/Templates/WizardTemplates/CashAccountProposal/CashAccountProposal';
import { MessagesPage } from 'Views/Page/Content/Templates/MessagesPage/MessagesPage';
import FQAdminPanel from 'Views/Page/Content/Templates/FQAdminPanel';
import PaymentStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/Buy/PaymentStep';
import FAQGroupTemplate from 'Views/Page/Content/Templates/FAQGroup';
import FacetPlanClickToSyncAccountMappingTemplate
  from 'Views/Page/Content/Templates/FacetPlanClickToSync/AccountMapping/Template';
import FacetPlanClickToSyncReviewChangesTemplate
  from 'Views/Page/Content/Templates/FacetPlanClickToSync/ReviewChanges/Template';
import ScenarioReviewScheduledTransfersToDeleteStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioReviewScheduledTransfersToDeleteStepTemplate';
import StartKnowYourCustomerVerificationTemplate
  from 'Views/Page/Content/Templates/KnowYourCustomerVerificationTemplate/StartKnowYourCustomerVerificationTemplate';
import CashFlowPageTemplate from 'Views/Page/Content/Templates/CashFlowPageTemplate';
import { NMARSRequestsPageTemplate } from 'Views/Page/Content/Templates/nmarsRequestsPageTemplate';
import CashFlowMDCPageTemplate from 'Views/Page/Content/Templates/CashFlowMDCPageTemplate';
import DoLQuestionnaireTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/DoLQuestionnaireTemplate/DoLQuestionnaireTemplate';
import PlannerAccountOpeningAccountInformationTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningAccountInformation/PlannerAccountOpeningAccountInformationTemplate';
import PlannerAccountOpeningRiskToleranceTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningRiskToleranceContent/PlannerAccountOpeningRiskToleranceTemplate';
import { ClientDashboardPageTemplate } from 'Views/Page/Content/Templates/ClientDashboardPageTemplate';
import { PlanSummaryPageContainerTemplate } from 'Views/Page/Content/Templates/planSummaryPageTemplate';
import TransitionsDashboardPageTemplate from 'Views/Page/Content/Templates/TransitionsDashboardPage';
import TaxDiagnosticPlannerPageTemplate from 'Views/Page/Content/Templates//TaxDiagnosticPlannerPage';
import TaxDiagnosticContextStep from 'Views/Page/Content/Templates/TaxDiagnosticContextStep';
import DesiredOutcomesSummaryPageTemplate from 'Views/Page/Content/Templates/DesiredOutcomesSummaryPage';
import {
  SimpleHeroPaperEmptyPageTemplate,
  SimpleHeroPaperEmptyPageWithoutRefreshTemplate,
} from 'Views/Page/Content/Templates/SimpleHeroPaperEmptyPageTemplate';
import ConnectionPageTemplate from 'Views/Page/Content/Templates/ConnectionsPageTemplate';
import { LeadPageForm } from 'Views/Page/Content/Templates/LeadPageTemplate/LeadPageForm';
import ScenarioSelectionRedefinedScenarioDetailsStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedScenarioDetailsStepTemplate';
import ScenarioSelectionRedefinedTheYearAheadStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadOutflowStepTemplate';
import ScenarioSelectionRedefinedDecisionStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedDecisionStepTemplate';
import { NMARSEmptyPageTemplate } from 'Views/Page/Content/Templates/nmarsEmptyPageTemplate';
import {
  AccountOpeningV2AccountAgreementStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2AccountAgreementStepTemplate';
import { RoadmapExplorerPageTemplate } from 'Views/Page/Content/Templates/roadmapExplorerPageTemplate';
import { GuidedHouseholdReviewGoalsWithThresholdsPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewGoalsWithThresholdsPageTemplate';
import { GuidedHouseholdReviewIntroToGoalThresholdsPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewIntroToGoalThresholdsPageTemplate';
import { GuidedHouseholdReviewGoalPriorityPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewGoalPriorityPageTemplate';
import { GuidedHouseholdReviewFamilyPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewFamilyPageTemplate';
import { GuidedHouseholdReviewGoalListPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewGoalListPageTemplate';
import { GuidedHouseholdReviewOwnVsOwePageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewOwnVsOwePageTemplate';
import { GuidedHouseholdReviewCashFlowPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewCashFlowPageTemplate';
import { GuidedHouseholdReviewFutureIncomeAndExpensesPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewFutureIncomeAndExpensesPageTemplate';
import { GuidedHouseholdReviewIntroPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewIntroPageTemplate';
import { GuidedHouseholdReviewFoundationalGoalsPageTemplate } from 'Views/Page/Content/Templates/guidedHouseholdReviewFoundationalGoalsPageTemplate';
import { AccountOpeningV2FinishStepTemplate } from 'Views/Page/Content/Templates/accountOpeningV2FinishStepTemplate';
import ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate';
import { AccountDebitFinishStepTemplate } from 'Views/Page/Content/Templates/AccountDebitFinishStep';
import PaymentInfoProfileSubpage
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/PaymentInfoProfileSubpage/PaymentInfoProfileSubpage';
import TaxDiagnosticModuleIntroStepTemplate from 'Views/Page/Content/Templates/TaxDiagnosticModuleIntroStepTemplate';
import TaxDiagnosticQuestionStepTemplate from 'Views/Page/Content/Templates/TaxDiagnosticQuestionStepTemplate';
import PartialRothConversionConsentTemplate
  from 'Views/Page/Content/Templates/PartialRothConversionConsentTemplate/ActivationAccountFundingInstructions';
import { OldKYCIntroStepTemplate as KYCIntroStepTemplate } from 'Views/Page/Content/Templates/kycIntroStep';
import AccountOpeningKYCFailStepTemplate from 'Views/Page/Content/Templates/AccountOpeningKYCFailStep';
import ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate';
import ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate';
import ScenarioSelectionRedefinedTaxStrategyStepTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate';
import ProposalScenarioTaxStrategyDetailsStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/wizard';
import { AccountOpeningV2KYCIntroStepTemplate } from 'Views/Page/Content/Templates/AccountOpeningV2KYCIntroStep';
import {
  AccountOpeningV2UncommonSituationsStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2UncommonSituationsStepTemplate';
import {
  AccountOpeningV2UncommonSituationsUploadStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2UncommonSituationsUploadStepTemplate';
import {
  AccountOpeningV2BeneficiaryIntroStep,
} from 'Views/Page/Content/Templates/AccountOpeningV2BeneficiaryIntroStep';
import {
  AccountOpeningV2TrustedContactIntroStep,
} from 'Views/Page/Content/Templates/AccountOpeningV2TrustedContactIntroStep';
import {
  AccountOpeningV2BeneficiaryDetailStep,
} from 'Views/Page/Content/Templates/AccountOpeningV2BeneficiaryDetailStep';
import {
  AccountOpeningV2BeneficiaryAllocationsStep,
} from 'Views/Page/Content/Templates/AccountOpeningV2BeneficiaryAllocationsStep';
import {
  AccountOpeningV2PersonalInformationStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2PersonalInformationStepTemplate';
import {
  AccountOpeningV2KYCFailureNotLockedOutStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2KYCFailureNotLockedOutStepTemplate';
import {
  AccountOpeningV2KYCLockedOutStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2KYCLockedOutStepTemplate';
import { AccountOpeningV2WaitStepTemplate } from 'Views/Page/Content/Templates/accountOpeningV2WaitStepTemplate';
import {
  AccountOpeningV2WrongPersonStepTemplate,
} from 'Views/Page/Content/Templates/accountOpeningV2WrongPersonStepTemplate';
import {
  ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepContainer,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep';
import CapitalizeRolloverAccountStatusStepTemplate
  from 'Views/Page/Content/Templates/CapitalizeRolloverAccountsStatusStepTemplate';
import CapitalizeRolloverIntroStepTemplate from 'Views/Page/Content/Templates/CapitalizeRolloverIntroStepTemplate';
import CapitalizeRolloverWebviewStepTemplate from 'Views/Page/Content/Templates/CapitalizeRolloverWebviewStepTemplate';
import ManualRolloverTemplate from 'Views/Page/Content/Templates/ManualRolloverTemplate';
import RolloverConciergeIntroStepTemplate from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate';
import {
  AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStepTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/AnnualInvestmentReviewInvestmentObjectivesRetirementAge';
import ManualRolloverMeetingAlreadyScheduledStepTemplate
  from 'Views/Page/Content/Templates/ManualRolloverMeetingAlreadyScheduledStepTemplate';
import AccountOpeningTrustInformation from 'Views/Page/Content/Templates/AccountOpeningTrustInformationStep';
import AccountOpeningTrustAddress from 'Views/Page/Content/Templates/AccountOpeningTrustAddressStep';
import { ReferralPage } from 'Views/Page/Content/Templates/ReferralPage';
import { EndorserAgreementPage } from 'Views/Page/Content/Templates/EndorserAgreementPage';
import InvestorProfilePageTemplate from 'Views/Page/Content/Templates/InvestorProfilePageTemplate';
import {
  OnboardingInvestmentProfileInvestingMindsetTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingMindsetTemplate';
import {
  OnboardingInvestmentProfileInvestingToolboxTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingToolboxTemplate';
import RoadmapExecutiveSummaryStepTemplate from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryStepTemplate';
import {
  RoadmapExecutiveSummaryTemplate,
} from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummaryTemplate';
import ManagedAccountModelUpdateRequestPageTemplate
  from 'Views/Page/Content/Templates/ManagedAccountModelUpdateRequestPageTemplate';
import ManagedAccountModelUpdateRequestAggregatePageTemplate
  from 'Views/Page/Content/Templates/ManagedAccountModelUpdateRequestAggregatePageTemplate';
import {
  ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate';
import { TaxHomePage } from 'Views/Page/Content/Templates/TaxHomePage';
import { TaxWaitlistPage } from 'Views/Page/Content/Templates/TaxWaitlistPage';
import { TaxDashboardPage } from 'Views/Page/Content/Templates/TaxDashboardPage';
import { TaxFilingPartnerPage } from 'Views/Page/Content/Templates/TaxFilingPartnerPage';
import ManagedAccountDocumentsPage
  from 'Views/Page/Content/Templates/ManagedAccountDocumentsPage/ManagedAcountDocumentsPage';
import { GoalsPage } from 'Views/Page/Content/Templates/goalsPage/GoalsPage';
import {
  GuidedHouseholdReviewOutroPageTemplate,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewOutroPageTemplate';
import {
  GuidedHouseholdReviewLeversTransitionPageTemplate,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewLeversTransitionPageTemplate';
import {
  GuidedHouseholdReviewOutroHowWeBringThisToLifeTemplate,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewOutroHowWeBringThisToLifeTemplate';
import {
  GuidedHouseholdReviewOutroForHeadStartTemplate,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewOutroForHeadStartTemplate';
import {
  GuidedHouseholdReviewOutroScheduleTemplate,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewOutroScheduleTemplate';
import {
  PM2JourneyRoadmapAdjustmentDiffTemplate,
} from 'Views/Page/Content/Templates/pm2JourneyRoadmapAdjustmentDiffTemplate';
import OutcomeLauncher from 'Views/Page/Content/Modal/Layouts/OutcomeLauncher';
import StrategyLauncher from 'Views/Page/Content/Modal/Layouts/StrategyLauncher';
import StrategyResetConfirmation from 'Views/Page/Content/Modal/Layouts/StrategyResetConfirmation';
import StrategyLaunderOverrideSet from 'Views/Page/Content/Modal/Layouts/StrategyLauncher/MetaOverrideSet';
import WhatIfBaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import BaseOverride, { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import TemplateOverrideSet from 'Views/Page/Content/Modal/Layouts/Template/MetaOverrideSet';
import FacetPlanAddIncome from 'Views/Page/Content/Modal/Layouts/FacetPlanAddIncome';
import FacetPlanAddIncomeOverrideSet from 'Views/Page/Content/Modal/Layouts/FacetPlanAddIncome/MetaOverrideSet';
import PlannerTransitionSegmentKey from 'Views/Page/Content/Modal/Layouts/PlannerTransitionSegmentKey';
import PlannerTransitionSegmentKeyOverrideSet
  from 'Views/Page/Content/Modal/Layouts/PlannerTransitionSegmentKey/MetaOverrideSet';
import ModelAssignmentOverrideSet
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningModelAssignmentTemplate/ModelAssignment/MetaOverrideSet';
import DefineTarget401KInvestmentStep from 'Views/Page/Content/Modal/Layouts/DefineTarget401KInvestmentStep';
import FacetPlanRetirementTargetStep from 'Views/Page/Content/Modal/Layouts/FacetPlanRetirementTargetStep';
import FacetPlan403BStrategyContributionDetailsStep
  from 'Views/Page/Content/Modal/Layouts/FacetPlan403BStrategyContributionDetailsStep';
import EducationOutcomeConfirmAgeStepOverride
  from 'Views/Page/Content/Modal/Layouts/EducationOutcomeConfirmAgeStep/MetaOverrideSet';
import PlannerAccountOpeningAccountInformationOverride
  from 'Views/Page/Content/Modal/Layouts/PlannerAccountOpeningAccountInformation/MetaOverrideSet';
import PlannerAccountOpeningAccountInformationLayout
  from 'Views/Page/Content/Modal/Layouts/PlannerAccountOpeningAccountInformation/index';
import FacetPlanAddExpenseOverrideSet from 'Views/Page/Content/Modal/Layouts/FacetPlanAddExpense/MetaOverrideSet';
import FacetPlanAddBalanceTransferOverrideSet
  from 'Views/Page/Content/Modal/Layouts/FacetPlanAddBalanceTransfer/MetaOverrideSet';
import StartEndAndMonths from 'Views/Page/Content/Modal/Layouts/StartEndAndMonths';
import RetirementPlanMatch from 'Views/Page/Content/Modal/Layouts/RetirementPlanMatch';
import FacetPlanOutcomeGoalOneTimeExpense from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeGoalOneTimeExpense';
import RetirementPlanMatchOverrideSet from 'Views/Page/Content/Modal/Layouts/RetirementPlanMatch/MetaOverrideSet';
import GenericStrategyStartDateStep from 'Views/Page/Content/Modal/Layouts/GenericStrategyStartDateStep';
import { withWhatIfNavigationAndHeader } from 'Views/Page/Content/Modal/Layouts/withWhatIfNavigationAndHeader';
import ManagedAccountAllocationCleanupDialog
  from 'Views/Page/Content/Modal/Layouts/ManagedAccountAllocationCleanupDialog';
import {
  Layout as ManagedAccountModelUpdateRequestDialog,
} from 'Views/Page/Content/Modal/Layouts/ManagedAccountModelUpdateRequestDialog';

import {
  ManagedAccountAllocationCleanupDialogOverride,
} from 'Views/Page/Content/Templates/ManagedAccountAllocationCleanupTemplate/MetaOverrideSet';
import NoopFinishStep from 'Views/Page/Content/Modal/Layouts/NoopFinishStep';
import WizardBadgeStepLayout from 'Views/Page/Content/Modal/Layouts/WizardBadgeStepLayout';
import Three120LetterLayout from 'Views/Page/Content/Modal/Layouts/Three120LetterLayout';
import {
  Layout as FacetPlanChooseStartEndDateStepLayout,
  metaOverrideSet as FacetPlanChooseStartEndDateStepOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanChooseStartEndDateStep';
import WizardStepLayout from 'Views/Page/Content/Modal/Layouts/WizardStepLayout';
import {
  Layout as ScenarioAcceptanceIntroStepLayout,
  metaOverrideSet as ScenarioAcceptanceIntroStepOverride,
} from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptanceIntroStep';
import {
  Layout as MemberActionItemLayout,
  metaOverrideSet as MemberActionItemOverride,
} from 'Views/Page/Content/Modal/Layouts/MemberActionItem';
import { Layout as InformationalLayout } from 'Views/Page/Content/Modal/Layouts/Informational';
import {
  Layout as InvestorProfileAdditionalInfoLayout,
} from 'Views/Page/Content/Modal/Layouts/InvestorProfileAdditionalInfo';
import {
  Layout as ScenarioAcceptanceHowToStepLayout,
  metaOverrideSet as ScenarioAcceptanceHowToStepOverride,
} from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptanceHowToStep';
import {
  Layout as ScenarioAcceptanceConfirmStepLayout,
  metaOverrideSet as ScenarioAcceptanceConfirmStepOverride,
} from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptanceConfirmStep';
import {
  Layout as AccountSummaryLayout,
  metaOverrideSet as AccountSummaryOverride,
} from 'Views/Page/Content/Modal/Layouts/AccountSummary';
import WizardAutoCompleteMetaOverrideSet
  from 'Views/Page/Content/Templates/WizardTemplates/WizardAutoComplete/MetaOverrideSet';
import WizardStepOverride, {
  wizardHiddenFields,
} from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import DetailListLayout from 'Views/Page/Content/Modal/Layouts/WizardStepDetailListLayout';
import DefaultWithCloseAndRefreshStepLayout from 'Views/Page/Content/Modal/Layouts/DefaultWithCloseAndRefreshStep';
import DefaultWithCloseAndRefreshStepLayoutWithDelete
  from 'Views/Page/Content/Modal/Layouts/DefaultWithCloseAndRefreshStepWithDelete';
import MultipleYesNoQuestionsLayout from 'Views/Page/Content/Modal/Layouts/WizardMutipleYesNoQuestionsLayout';
import WizardAttachmentsLayoutMateOverrideSet
  from 'Views/Page/Content/Templates/WizardTemplates/WizardAttachmentsTemplate/MetaOverrideSet';
import WizardAttachmentsLayout from 'Views/Page/Content/Modal/Layouts/WizardAttachmentsLayout';
import BigPickListTemplateOverrideSet from 'Views/Page/Content/Templates/BigPickListTemplate/MetaOverrideSet';
import BigPickListLayout from 'Views/Page/Content/Modal/Layouts/BigPickListLayout';
import WizardCompleteLayout from 'Views/Page/Content/Modal/Layouts/WizardCompleteLayout';
import WizardBigHierarchyMultipicklistControlLayout
  from 'Views/Page/Content/Modal/Layouts/WizardBigHierarchyMultipicklistControlLayout';
import PlannerAccountOpeningModelAssignmentLayout
  from 'Views/Page/Content/Modal/Layouts/PlannerAccountOpeningModelAssignmentLayout/ModelAssignment';
import PlannerAccountOpeningModelAssignmentESGConfirmationLayout
  from 'Views/Page/Content/Modal/Layouts/PlannerAccountOpeningModelAssignmentLayout/EsgConfirmation';
import WizardAutoCompletePrefillHouseholdIdLayout
  from 'Views/Page/Content/Modal/Layouts/WizardAutoCompletePrefillHouseholdIdLayout';
import UploadOrSelectFromSecureFilesStepLayout
  from 'Views/Page/Content/Modal/Layouts/UploadOrSelectFromSecureFilesStepLayout';
import SelectFileStepLayout from 'Views/Page/Content/Modal/Layouts/SelectFileStepLayout';
import UploadFileStepLayout from 'Views/Page/Content/Modal/Layouts/UploadFileStepLayout';
import ApexFundingAccountListStep from 'Views/Page/Content/Modal/Layouts/ApexFundingAccountListStep';
import ApexFundingAccountResultStep from 'Views/Page/Content/Modal/Layouts/ApexFundingAccountResultStep';
import PlannerAccountOpeningRiskTolerance from 'Views/Page/Content/Modal/Layouts/PlannerAccountOpeningRiskTolerance';
import ACHTransferTemplateOverride, {
  TransferRolloverAdditionalInstructionsOverride,
} from 'Views/Page/Content/Templates/ACHTransferTemplate/Content/ACHTransferTemplateOverride';
import whatIfMetaOverrideSet
  from 'Views/Page/Content/RightSidebar/Content/Templates/DefaultTemplate/WhatIfMetaOverrideSet';
import {
  Layout as FacetPlanOutcomeQuickEditEmergencyFundLayout,
  metaOverrideSet as FacetPlanOutcomeQuickEditEmergencyFundMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeQuickEditEmergencyFund';
import {
  Layout as EstatePlanRequestStepLayout,
  metaOverrideSet as EstatePlanRequestStepMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanRequestStepLayout';
import {
  Layout as FacetPlanOutcomeQuickEditEducationLayout,
  metaOverrideSet as FacetPlanOutcomeQuickEditEducationMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeQuickEditEducation';
import DefaultWithCloseAndRefreshStepOverride
  from 'Views/Page/Content/Modal/Layouts/DefaultWithCloseAndRefreshStep/MetaOverrideSet';
import {
  Layout as TransactionDetails,
  metaOverrideSet as TransactionDetailsMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/TransactionDetails';
import ModelChangeEventsPage, {
  ModelChangeEventsPageMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/ModelChangeEventsPage';
import FAQ, { FAQMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/FAQ';
import AddFacetPlanExpense from 'Views/Page/Content/Modal/Layouts/AddFacetPlanExpense';
import AddFacetPlanExpenseStep from 'Views/Page/Content/Modal/Layouts/AddFacetPlanExpenseStep';
import AddFacetPlanBalanceTransfer from 'Views/Page/Content/Modal/Layouts/AddFacetPlanBalanceTransfer';
import AddFacetPlanBalanceTransferStep from 'Views/Page/Content/Modal/Layouts/AddFacetPlanBalanceTransferStep';
import {
  Layout as FacetPlanNextUpDoLACATAnswerStepLayout,
  metaOverrideSet as facetPlanNextUpDoLACATAnswerStepMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanNextUpDoLACATAnswerStepLayout';
import DolQuestionnaireModalTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/DoLQuestionnaireTemplate/DolQuestionnaireModalTemplate';
import dolMetaOverride from 'Views/Page/Content/Templates/WizardTemplates/DoLQuestionnaireTemplate/dolMetaOverride';
import FundingInstructionFundingTypeLayout
  from 'Views/Page/Content/Modal/Layouts/FundingInstructionFundingTypeStep/FundingInstructionFundingTypeStep';
import {
  EstatePlanningBuyPaymentStep,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyPayment';
import {
  EstatePlanningBuyIntroStepLayout,
  EstatePlanningBuyLearnMoreStepLayout,
  EstatePlanningBuySuccessStepLayout,
  EstatePlanningInitializeIntroStepLayout,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts';
import EstatePlanningBuySuccessMetaOverride
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuySuccess/Layout/EstatePlanningBuySuccessMetaOverride';
import EstatePlanningBuyIntroMetaOverride
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyIntro/Layout/EstatePlanningBuyIntroMetaOverride';
import {
  Layout as CreateYourPlanReviewStepLayout,
  metaOverrideSet as CreateYourPlanReviewMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/CreateYourPlanReviewStep';
import EstatePlanningBuyLearnMoreMetaOverride
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyLearnMore/Layout/EstatePlanningBuyLearnMoreMetaOverride';
import EstatePlanningInitializeIntroMetaOverride
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningInitializeIntro/Layout/EstatePlanningInitializeIntroMetaOverride';
import AccountMissingInformationTemplate
  from 'Views/Page/Content/Templates/accountMissingInformationTemplate/accountMissingInformationTemplate';
import { AnalyzeYourExpenses } from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesTemplate/AnalyzeYourExpenses';
import {
  AnalyzeYourExpensesOverride,
} from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesTemplate/AnalyzeYourExpensesOverride';
import {
  AnalyzeYourExpensesAnswerResultTemplate,
} from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesAnswerResultTemplate/AnalyzeYourExpensesAnswerResultTemplate';
import {
  AnalyzeYourExpensesAnswerResultOverride,
} from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesAnswerResultTemplate/AnalyzeYourExpensesAnswerResultOverride';
import {
  MissingAccountsAndRealAssets,
} from 'Views/Page/Content/Templates/MissingAccountsAndRealAssets/MissingAccountsAndRealAssets';
import {
  MissingAccountsAndRealAssetOverride,
} from 'Views/Page/Content/Templates/MissingAccountsAndRealAssets/MissingAccountsAndRealAssetOverride';
import {
  MissingRealAssetsDetailsTemplate,
} from 'Views/Page/Content/Templates/MissingRealAssetDetailsTemplate/MissingRealAssetsDetailsTemplate';
import FDWizardModalWrapperOverrides
  from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper/Layout/metaOverrideSet';
import { SelectInstitutionStepTemplate } from 'Views/Page/Content/Modal/Layouts/selectInstitutionStep/template';
import { SelectInstitutionStepOverride } from 'Views/Page/Content/Modal/Layouts/selectInstitutionStep/override';
import {
  FacetPlanVirtualAccountSelectInstitutionStepTemplate,
} from 'Views/Page/Content/Modal/Layouts/facetPlanVirtualAccountSelectInstitutionStepTemplate/template';
import {
  FacetPlanVirtualAccountSelectInstitutionStepOverride,
} from 'Views/Page/Content/Modal/Layouts/facetPlanVirtualAccountSelectInstitutionStepTemplate/override';
import {
  SelectAssetLiabilityTypeTemplate,
} from 'Views/Page/Content/Modal/Layouts/SelectAssetLiabilityType/SelectAssetLiabilityTypeTemplate';
import {
  SelectAssetLiabilityTypeOverride, SelectAssetLiabilityTypeDOOverride,
} from 'Views/Page/Content/Modal/Layouts/SelectAssetLiabilityType/SelectAssetLiabilityTypeOverride';
import {
  BalanceSheetAccountInfoOverride,
} from 'Views/Page/Content/Templates/balanceSheetAccountInfo/balanceSheetAccountInfoOverride';
import {
  DigitalOnboardingAccountInfoOverride,
} from 'Views/Page/Content/Templates/DigitalOnboardingAccountInfo/metaOverride';
import {
  DigitalOnboardingRealAssetInfoOverride,
} from 'Views/Page/Content/Templates/DigitalOnboardingRealAssetInfo/metaOverride';
import BalanceSheetAccountInfoTemplate from 'Views/Page/Content/Templates/balanceSheetAccountInfo/balanceSheetAccountInfoTemplate';
import DigitalOnboardingAccountInfoTemplate from 'Views/Page/Content/Templates/DigitalOnboardingAccountInfo/DigitalOnboardingAccountInfoTemplate';
import DigitalOnboardingRealAssetInfoTemplate from 'Views/Page/Content/Templates/DigitalOnboardingRealAssetInfo/DigitalOnboardingRealAssetInfoTemplate';
import { CreditScoreSkipLayout } from 'Views/Page/Content/Modal/Layouts/CreditScoreSkipLayout/creditScoreSkipLayout';
import { KYCIntroStepLayout } from 'Views/Page/Content/Modal/Layouts/KYCIntroStep/layout';
import {
  metaOverrideSet as KYCIntroStepMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/KYCIntroStep/metaOverrideSet';
import {
  RetirementAgeGoalSeekResultsStepLayout,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeGoalSeekResultsStep/layout';
import {
  RetirementAgeGoalSeekViewResultsOverride,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeGoalSeekResultsStep/override';
import { PM2JourneyInvestingImageScreenTemplate } from 'Views/Page/Content/Templates/pm2JourneyInvestingImageScreenTemplate';
import { PM2JourneyInvestingTidbitsTemplate } from 'Views/Page/Content/Templates/pm2JourneyInvestingTidbitsTemplate';
import { PM2JourneyIntroOverviewPageTemplate } from 'Views/Page/Content/Templates/pm2JourneyIntroOverviewPageTemplate';
import { PM2JourneyScheduleMeetingLaterPageTemplate } from 'Views/Page/Content/Templates/pm2JourneyScheduleMeetingLaterPageTemplate';
import { PM2JourneyMemberQuestionsChecklistTemplate } from 'Views/Page/Content/Templates/pm2JourneyMemberQuestionsChecklistTemplate';
import FacetPlanOutcomeQuickEditRetirementLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeQuickEditRetirement';
import FacetPlanOutcomeQuickEditRetirementStepOverride
  from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeQuickEditRetirement/metaOverrideSet';
import RetirementOutcomeClientAssumptionsStepOverrideSet
  from 'Views/Page/Content/Modal/Layouts/retirementOutcomeClientAssumptionsStep/metaOverrideSet';
import { ProposalExpirationLayout } from 'Views/Page/Content/Modal/Layouts/ProposalExpiration';
import ConciergeTransactionTemplate
  from 'Views/Page/Content/Modal/Layouts/ConciergeTransactionTemplate/ConciergeTransactionTemplate';
import MetaOverrideSet from 'Views/Page/Content/Modal/Layouts/ConciergeTransactionTemplate/MetaOverrideSet';
import EstatePlanStatusStepLayout from 'Views/Page/Content/Modal/Layouts/EstatePlanStatusStep/Layout';
import EstatePlanStatusStepMetaOverrideSet from 'Views/Page/Content/Modal/Layouts/EstatePlanStatusStep/MetaOverrideSet';
import EstatePlanningNextStepDependingOnStatusLayout
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningNextStepDependingOnStatusStep/Layout';
import EstatePlanningNextStepDependingOnStatusMetaOverrideSet
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningNextStepDependingOnStatusStep/MetaOverrideSet';
import { featureToggleMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/featureToggle/metaOverrideSet';
import FeatureToggleLayout from 'Views/Page/Content/Modal/Layouts/featureToggle/layout';
import {
  RetirementAgeGoalSeekPrioritiesStepLayout,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeGoalSeekPrioritiesStep/layout';
import {
  RetirementAgeGoalSeekPriorityOverride,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeGoalSeekPrioritiesStep/override';
import {
  RetirementAgeGoalSeekFineTuneStepLayout,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeFineTuneStep/layout';
import {
  RetirementAgeGoalSeekFineTuneOverride,
} from 'Views/Page/Content/Modal/Layouts/RetirementAgeFineTuneStep/override';
import {
  ManageFacetPlanMoneyMovementDetailsStepLayout,
} from 'Views/Page/Content/Modal/Layouts/ManageFacetPlanMoneyMovementDetailsStep/ManageFacetPlanMoneyMovementDetailsStepLayout';
import BalanceSheetEditAccountSelectInstitutionStepTemplate from 'Views/Page/Content/Modal/Layouts/balanceSheetEditAccountSelectInstitutionStepTemplate/template';
import {
  BalanceSheetEditAccountSelectInstitutionStepOverride,
} from 'Views/Page/Content/Modal/Layouts/balanceSheetEditAccountSelectInstitutionStepTemplate/override';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import {
  ScenarioSelectionModelDetailsStepTemplate,
} from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionRedefined/ScenarioSelectionModelDetailsStepTemplate/ScenarioSelectionModelDetailsStepTemplate';
import { QueryVal } from 'Helpers/Query';
import { STEP_LINK_QUERY_PARAM_NAME } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import RoadmapExplorerManagePathsLayout from 'Views/Page/Content/Templates/roadmapExplorerPageTemplate/managePaths';
import { FacetPlanRetirementWithdrawalLayout } from 'Views/Page/Content/Templates/facetPlanRetirementWithdrawalTemplate/layout';
import { metaOverrideSet as FacetPlanRetirementWithdrawalMetaOverrideSet } from 'Views/Page/Content/Templates/facetPlanRetirementWithdrawalTemplate/metaOverrideSet';
import {
  BalanceSheetEditAccountSelectInstitutionStepDOTemplate,
} from 'Views/Page/Content/Modal/Layouts/BalanceSheetEditAccountSelectInstitutionStepDO/Layout';
import {
  SelectOutcomesStepTemplate,
} from 'Views/Page/Content/Modal/Layouts/SelectOutcomesStepTemplate/SelectOutcomesStepTemplate';
import {
  GoalDetailStepMetaOverride,
  SelectOutcomeStepMetaOverride,
} from 'Views/Page/Content/Modal/Layouts/SelectOutcomesStepTemplate/MetaOverride';
import { SaveForRetirementLayout } from 'Views/Page/Content/Modal/Layouts/SaveForRetirementStep/SaveForRetirementLayout';
import { SaveForRetirementOverride } from 'Views/Page/Content/Modal/Layouts/SaveForRetirementStep/MetaOverride';
import SelectManualOrLinkStepLayout from 'Views/Page/Content/Modal/Layouts/SelectManualOrLinkStepLayout/Layout';
import { BalanceSheetAccountTypeLayout } from 'Views/Page/Content/Modal/Layouts/BalanceSheetAccountTypeStep/Layout';
import { BalanceSheetAccountTypeDOLayout } from 'Views/Page/Content/Modal/Layouts/BalanceSheetAccountTypeDOStep/Layout';
import { BalanceSheetRealAssetTypeLayout } from 'Views/Page/Content/Modal/Layouts/BalanceSheetRealAssetTypeStep/Layout';
import {
  BalanceSheetRealAssetTypeDOLayout,
} from 'Views/Page/Content/Modal/Layouts/BalanceSheetRealAssetTypeDOStep/Layout';
import ActionCompletionGreatJobStepTemplate from 'Views/Page/Content/Templates/ActionCompletionGreatJobStepTemplate';
import {
  Layout as FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout,
  metaOverrideSet as FacetPlanOutcomeQuickEditEmergencyFundWithStagesMetaOverrideSet,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanOutcomeQuickEditEmergencyFundWithStages';
import {
  DeliverableIntroductionWizardStepLayout, DeliverableIntroductionWizardStepMetaOverride,
} from 'Views/Page/Content/Modal/Layouts/DeliverableIntroductionWizardStep/DeliverableIntroductionWizardStepLayout';
import MeetingInfoOutroStepTemplate from 'Views/Page/Content/Templates/MeetingInfoOutroStep';
import { PM2JourneyPathExplorerExit } from 'Views/Page/Content/Modal/Layouts/PM2JourneyPathExplorerExit';
import { metaOverrideSet as PM2JourneyPathExplorerExitMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/PM2JourneyPathExplorerExit/metaOverrideSet';
import { Layout as TaxDashboardWizardAccountsLayout, metaOverrideSet as taxDashboardWizardAccountsLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardAccountsLayout';
import { Layout as TaxDashboardWizardInvestmentGainsLossesLayout, metaOverrideSet as taxDashboardWizardInvestmentGainsLossesLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardInvestmentGainsLossesLayout';
import { Layout as TaxDashboardWizardQuestionLayout, metaOverrideSet as taxDashboardWizardQuestionLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardQuestionLayout';
import { Layout as TaxDashboardWizardLottieLayout, metaOverrideSet as taxDashboardWizardLottieLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardLottieLayout';
import { Layout as TaxDashboardWizardTimelineLayout, metaOverrideSet as taxDashboardWizardTimelineLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardTimelineLayout';
import { Layout as TaxDashboardWizardUploadLayout, metaOverrideSet as taxDashboardWizardUploadLayoutMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/TaxDashboardWizardUploadLayout';
import ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker from './WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker';
import RoadmapHowToStartStepTemplate from './WizardTemplates/RoadmapDeliverable/HowToStartStepTemplate';
import { RoadmapGoalDetailsStepTemplate } from './WizardTemplates/RoadmapDeliverable/GoalDetailsStepTemplate/RoadmapGoalDetailsStepTemplate';
import RoadmapActionsThisMonthStepTemplate from './WizardTemplates/RoadmapDeliverable/ActionsThisMonthStepTemplate';
import RoadmapGoalsNext12MonthsStepTemplate from './WizardTemplates/RoadmapDeliverable/GoalsNext12MonthsStepTemplate';
import RoadmapChartStepTemplate from './WizardTemplates/RoadmapDeliverable/ChartStepTemplate';
import RoadmapGoalsByTimeStepTemplate from './WizardTemplates/RoadmapDeliverable/GoalsByTimeStepTemplate';
import YourRoadmapIsReadyStepTemplate from './WizardTemplates/RoadmapDeliverable/YourRoadmapIsReadyStepTemplate';
import WelcomeToYourRoadmapStepTemplate from './WizardTemplates/RoadmapDeliverable/WelcomeToYourRoadmapStepTemplate';
import WhatToDiscussStepTemplate from './WizardTemplates/RoadmapDeliverable/WhatToDiscussStep';
import { TemplateConfig as tc } from './TemplateConfig';
import HouseholdAccessJustificationPageTemplate from './HouseholdAccessJustificationPageTemplate';
import WhatIfClientRedefinedTemplate from './WhatIfClientRedefinedTemplate/WhatIfClientRedefined';
import WhatIfClientTemplate from './WhatIfClientTemplate';
import WhatIfTemplate from './WhatIfTemplate/Content';
import WizardStepTemplate from './WizardTemplates/WizardStepTemplate';
import TaxDiagnosticTaxStrategiesSummaryStep from './TaxDiagnosticTaxStrategiesSummaryStep';
import TaxDiagnosticNextStepsStepTemplate from './TaxDiagnosticNextStepsStepTemplate';
import HouseholdBalanceSheetPageTemplate from './HouseholdBalanceSheetPageTemplate';
import { AccountDebitSuccessStepTemplate } from './AccountDebitSuccessStepTemplate';
import { AccountDebitConfirmStepTemplate } from './AccountDebitConfirmStepTemplate';
import {
  ProductPurchaseSuccessStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/ProductPurchaseSuccessStepTemplate';
import {
  EstatePlanningRecommendationBuyStepTemplate,
  TaxFilingPurchaseTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationBuyStepTemplate';
import {
  EstatePlanningRecommendationQuizRecommendationStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQuizRecommendationStepTemplate';
import {
  EstatePlanningRecommendationQuizQuestionsStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQuizQuestionsStepTemplate';
import {
  EstatePlanningRecommendationQualificationSuccessStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQualificationSuccessStepTemplate';
import {
  EstatePlanningRecommendationQualificationFailedConfirmationStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQualificationFailedConfirmationStepTemplate';
import {
  EstatePlanningRecommendationQualificationFailedStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQualificationFailedStepTemplate';
import {
  EstatePlanningRecommendationQualificationStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationQualificationStepTemplate';
import {
  EstatePlanningRecommendationBasicInformationStepTemplate,
} from './WizardTemplates/EstatePlanningRecommendation/EstatePlanningRecommendationBasicInformationStepTemplate';
import { EstatePlanningManagementPageTemplate } from './EstatePlanningManagementPageTemplate';
import { ClientLayout, ClientMetaOverrideSet } from '../Modal/Layouts/Client';
import { DependentLayout, DependentMetaOverrideSet } from '../Modal/Layouts/Dependent';
import {
  Layout as DefaultFDWizardStepLayout,
  metaOverrideSet as defaultFDWizardStepMetaOverrideSet,
} from '../Modal/Layouts/DefaultFDWizardStep';
import { Layout as DefaultFDModalLayout, metaOverrideSet as defaultFDModalMetaOverrideSet } from '../Modal/Layouts/DefaultFDModal';
import {
  Layout as DesiredOutcomeDetails,
  metaOverrideSet as DesiredOutcomeDetailsOverrideSet,
} from '../Modal/Layouts/DesiredOutcomeDetails';
import {
  Layout as ScenarioAssumption,
  metaOverrideSet as ScenarioAssumptionMetaOverrideSet,
} from '../Modal/Layouts/ScenarioAssumption';
import {
  Layout as ScenarioSelectionAssumptionsAndDetails,
  metaOverrideSet as ScenarioSelectionAssumptionsAndDetailsMetaOverrideSet,
} from '../Modal/Layouts/ScenarioSelectionAssumptionsAndDetails';
import {
  Layout as AdditionalDetailsLayout,
  metaOverrideSet as AdditionalDetailsMetaOverrideSet,
} from '../Modal/Layouts/AdditionalDetails';
import { Layout as IncomeDetailsLayout, metaOverrideSet as IncomeDetailsOverrideSet } from '../Modal/Layouts/IncomeDetails';
import { Layout as GuidedHouseholdReviewSetAdjustmentExpenseLayout, metaOverrideSet as GuidedHouseholdReviewSetAdjustmentExpenseOverrideSet } from '../Modal/Layouts/guidedHouseholdReviewSetAdjustmentExpense';
import {
  Layout as IncomeDetailsStepLayout,
  metaOverrideSet as IncomeDetailsStepOverrideSet,
} from '../Modal/Layouts/IncomeDetailsStep';
import { Layout as HouseholdAddressLayout, metaOverrideSet as HouseholdAddressOverrideSet } from '../Modal/Layouts/HouseholdAddress';
import { Layout as AppAnnouncementLayout, metaOverrideSet as AppAnnouncementOverrideSet } from '../Modal/Layouts/appAnnouncement';
import {
  Layout as RequestChurnWithConcessionsIntroStepLayout,
  metaOverrideSet as RequestChurnWithConcessionsIntroStepOverrideSet,
} from '../Modal/Layouts/requestChurnWithConcessionsIntroStep';
import {
  Layout as RequestChurnWithConcessionsReasonsStepLayout,
  metaOverrideSet as RequestChurnWithConcessionsReasonsStepOverrideSet,
} from '../Modal/Layouts/requestChurnWithConcessionsReasonsStep';
import {
  Layout as RequestChurnWithConcessionsSelectionStepLayout,
  metaOverrideSet as RequestChurnWithConcessionsSelectionStepOverrideSet,
} from '../Modal/Layouts/requestChurnWithConcessionsSelectionStep';
import {
  Layout as RequestChurnWithConcessionsAdditionalFeedbackStepLayout,
  metaOverrideSet as RequestChurnWithConcessionsAdditionalFeedbackStepOverrideSet,
} from '../Modal/Layouts/requestChurnWithConcessionsAdditionalFeedbackStep';
import {
  Layout as RequestChurnWithConcessionsCompleteStepLayout,
  metaOverrideSet as RequestChurnWithConcessionsCompleteStepOverrideSet,
} from '../Modal/Layouts/requestChurnWithConcessionsCompleteStep';
import {
  Layout as CashFlowPageExpenseLayout,
  metaOverrideSet as CashFlowPageExpenseOverrideSet,
} from '../Modal/Layouts/CashFlowPageExpenseModal';
import {
  Layout as BulkExpenseReducibilityAdjustmentStepLayout,
  metaOverrideSet as bulkExpenseReducibilityAdjustmentStepOverrideSet,
} from '../Modal/Layouts/bulkExpenseReducibilityAdjustmentStep';
import {
  Layout as ExpensesReducibleByStepLayout,
  metaOverrideSet as ExpensesReducibleByStepOverrideSet,
} from '../Modal/Layouts/ExpensesReducibleByStep';
import {
  Layout as CashFlowPageExpenseIntroLayout,
  metaOverrideSet as CashFlowPageExpenseIntroOverrideSet,
} from '../Modal/Layouts/CashFlowPageExpenseIntroModal';
import NavigateToPage from '../Modal/Layouts/NavigateToPage';
import WizardRefreshStepLayout from '../Modal/Layouts/WizardRefreshStep';
import OutcomeLauncherOverrideSet from '../Modal/Layouts/OutcomeLauncher/MetaOverrideSet';
import { Layout as DefaultStepLayout, metaOverrideSet as DefaultStepMetaOverrideSet } from '../Modal/Layouts/DefaultStep';
import {
  Layout as EditManagedAccountNickname,
  metaOverrideSet as EditManagedAccountNicknameOverrideSet,
} from '../Modal/Layouts/EditManagedAccountNickname';
import { Layout as EmergencyFundOutcomeExpenseReviewStepLayout } from '../Modal/Layouts/EmergencyFundOutcomeExpenseReviewStepLayout';
import {
  Layout as EmergencyFundOutcomeSummaryStepLayout,
  metaOverrideSet as EmergencyFundOutcomeSummaryStepOverrideSet,
} from '../Modal/Layouts/EmergencyFundOutcomeSummaryStepLayout';
import {
  Layout as FacetPlanEmergencyFundStageInfoWizardLayout,
} from './FacetPlanEmergencyFundStageInfoWizardLayout';
import {
  Layout as VirtualAccountFlowLayout,
  metaOverrideSet as VirtualAccountFlowMetaOverrideSet,
} from '../Modal/Layouts/VirtualAccountSetupFlow';
import {
  Layout as PlannerTransitionHouseholdLayout,
  metaOverrideSet as PlannerTransitionHouseholdMetaOverrideSet,
} from '../Modal/Layouts/PlannerTransitionHousehold';
import { Layout as PlannerGuideLayout, metaOverrideSet as PlannerGuideMetaOverrideSet } from '../Modal/Layouts/PlannerGuideLayout';
import { Layout as AddNewInstitutionLayout, metaOverrideSet as AddNewInstitutionMetaOverrideSet } from '../Modal/Layouts/AddNewInstitutionLayout';
import { Layout as FinancialInstitutionConnectionLayout, metaOverrideSet as FinancialInstitutionConnectionMetaOverrideSet } from '../Modal/Layouts/FinancialInstitutionConnectionLayout';
import { Layout as LinkOrAddAccountsStepLayout, metaOverrideSet as LinkOrAddAccountsStepMetaOverrideSet } from '../Modal/Layouts/LinkOrAddAccountsStep';
import { Layout as FailedToLinkAccountStepLayout, metaOverrideSet as FailedToLinkAccountStepMetaOverrideSet } from '../Modal/Layouts/FailedToLinkAccountStep';
import { Layout as RoadmapDeliverableCustomInsightLayout, metaOverrideSet as RoadmapDeliverableCustomInsightMetaOverrideSet } from '../Modal/Layouts/RoadmapDeliverableCustomInsight';

import { Layout as DummyLayout } from '../Modal/Layouts/DummyStep';
import { metaOverrideSet as AccountSelectionStepMetaOverrideSet } from '../Modal/Layouts/VirtualAccountSelection';
import {
  Layout as AuthenticationFactorLayout,
  metaOverrideSet as AuthenticationFactorOverrideSet,
} from '../Modal/Layouts/AuthenticationFactor';
import { Layout as TotpRegistrationLayout, metaOverrideSet as TotpRegistrationOverrideSet } from '../Modal/Layouts/TotpRegistration';
import {
  Layout as ManualMessageRoutingLayout,
  metaOverrideSet as ManualMessageRoutingOverrideSet,
} from '../Modal/Layouts/ManualMessageRouting';
import { Layout as SmsPhoneNumberLayout, metaOverrideSet as SmsPhoneNumberOverrideSet } from '../Modal/Layouts/SmsPhoneNumber';
import { Layout as SmsCodeLayout, metaOverrideSet as SmsCodeOverrideSet } from '../Modal/Layouts/SmsCode';
import { Layout as SmsRegistrationLayout, metaOverrideSet as SmsRegistrationOverrideSet } from '../Modal/Layouts/SmsRegistration';
import { metaOverrideSet as FacetPlanCustomDebtStackRankStepOverrideSet } from '../Modal/Layouts/FacetPlanCustomDebtStackRankStep';
import * as FacetPlanScenarioActivationConfirmation from '../Modal/Layouts/FacetPlanScenarioActivationConfirmation';
import { Layout as UserPasswordLayout, metaOverrideSet as UserPasswordOverrideSet } from '../Modal/Layouts/UserPassword';
import {
  Layout as GeneralSavingsOutcomeGeneralParametersStepLayout,
  metaOverrideSet as GeneralSavingsOutcomeGeneralParametersStepOverrideSet,
} from '../Modal/Layouts/GeneralSavingsOutcomeGeneralParametersStep';
import {
  Layout as FacetPlanVirtualAccountFundingInstructionsAccountDetailsStepLayout,
  metaOverrideSet as FacetPlanVirtualAccountFundingInstructionsAccountDetailsStepOverrideSet,
} from '../Modal/Layouts/FacetPlanVirtualAccountFundingInstructionsAccountDetailsStep';
import {
  Layout as FacetPlanVirtualAccountFundingInstructionsFundingTypeStepLayout,
  metaOverrideSet as FacetPlanVirtualAccountFundingInstructionsFundingTypeStepOverrideSet,
} from '../Modal/Layouts/FacetPlanVirtualAccountFundingInstructionsFundingTypeStep';
import {
  Layout as FacetPlanEducationOutcomeSummaryStepLayout,
  metaOverrideSet as FacetPlanEducationOutcomeSummaryStepOverrideSet,
} from '../Modal/Layouts/FacetPlanEducationOutcomeSummaryStep';
import {
  Layout as FacetPlanRetirementCustomWithdrawalStrategyLayout,
  metaOverrideSet as FacetPlanRetirementCustomWithdrawalStrategyMetaOverrideSet,
} from '../Modal/Layouts/FacetPlanRetirementCustomWithdrawalStrategy';
import {
  Layout as SimpleActionItemLayout,
  metaOverrideSet as SimpleActionItemMetaOverrideSet,
} from '../Modal/Layouts/SimpleActionItem';
import {
  Layout as JobEditNavigationStepLayout,
  metaOverrideSet as jobEditNavigationStepMetaOverrideSet,
} from '../Modal/Layouts/JobEditNavigationStep';
import {
  Layout as JobBasicInformationStepLayout,
  metaOverrideSet as JobBasicInformationStepMetaOverrideSet,
} from '../Modal/Layouts/JobBasicInformationStep';
import {
  Layout as JobDeductionsStepLayout,
  metaOverrideSet as JobDeductionsStepMetaOverrideSet,
} from '../Modal/Layouts/JobDeductionsStep';
import {
  Layout as JobAdditionalIncomeDetailStepLayout,
  metaOverrideSet as JobAdditionalIncomeDetailStepMetaOverrideSet,
} from '../Modal/Layouts/JobAdditionalIncomeDetailStep';
import { Layout as JobIntroStepLayout, metaOverrideSet as JobIntroStepMetaOverrideSet } from '../Modal/Layouts/JobIntroStep';
import {
  Layout as JobAdditionalIncomeListStepLayout,
  metaOverrideSet as JobAdditionalIncomeListStepMetaOverrideSet,
} from '../Modal/Layouts/JobAdditionalIncomeListStep';
import FacetPlanOutcomeGoalBaseInfoStepMetaOverrideSet from '../Modal/Layouts/FacetPlanOutcomeGoalBaseInfoStep/MetaOverrideSet';
import {
  Layout as KycUpdateMailingAddressStep,
  metaOverrideSet as KycUpdateMailingAddressStepMetaOverrideSet,
} from '../Modal/Layouts/KYCUpdateMailingAddressStepTemplate';
import FacetPlanOutcomeQuickEditGoalPropertyMetaOverrideSet
  from '../Modal/Layouts/FacetPlanOutcomeQuickEditGoalProperty/MetaOverrideSet';
import {
  Layout as FacetPlanProposalNextUpReviewLayout,
  metaOverrideSet as facetPlanProposalNextUpReviewMetaOverrideSet,
} from '../Modal/Layouts/FacetPlanProposalNextUpReview';
import PropertyOutcomeStrategySelectionStepOverrideSet from '../Modal/Layouts/PropertyOutcomeStrategySelectionStep/MetaOverrideSet';
import PropertyBuyStrategyPropertyClosingCostsStepLayout from '../Modal/Layouts/PropertyBuyStrategyPropertyClosingCostsStep';
import facetPlanMoneyMovementMetaOverrideSet from '../Modal/Layouts/FacetPlanAddMoneyMovement/MetaOverrideSet';
import propertyResetClosingCostsStepMetaOverrideSet from '../Modal/Layouts/PropertyBuyStrategyResetClosingCostsStep/metaOverrideSet';
import PropertyOutcomeBuyStrategyAccountAllocationStepOverrideSet
  from '../Modal/Layouts/PropertyOutcomeBuyStrategyAccountAllocationStep/metaOverrideSet';
import {
  Layout as SummarizeYourSpendingIntroLayout,
  metaOverrideSet as SummarizeYourSpendingIntroOverrides,
} from '../Modal/Layouts/SummarizeYourSpendingIntro';
import {
  Layout as SummarizeYourCommonExpensesLayout,
  metaOverrideSet as SummarizeYourCommonExpensesOverrides,
} from '../Modal/Layouts/SummarizeYourCommonExpenses';
import {
  Layout as SummarizeTheRestOfYourSpendingIntroLayout,
  metaOverrideSet as SummarizeTheRestOfYourSpendingIntroOverrides,
} from '../Modal/Layouts/SummarizeTheRestOfYourSpendingIntro';
import {
  Layout as MoneyFlowDetailsLayout,
  metaOverrideSet as MoneyFlowDetailsOverrideSet,
} from '../Modal/Layouts/MoneyFlowDetailLayout';
import {
  Layout as FundingAccountReauthenticationIntroLayout,
  metaOverrideSet as FundingAccountReauthenticationIntroOverride,
} from '../Modal/Layouts/FundingAccountReauthenticationIntroTemplate';

import {
  Layout as FundingAccountRelinkIntroLayout,
  metaOverrideSet as FundingAccountRelinkIntroOverride,
} from '../Modal/Layouts/FundingAccountRelinkIntroTemplate';
import {
  Layout as CreateYourPlanTextLayout,
  metaOverrideSet as CreateYourPlanTextMetaOverrides,
} from '../Modal/Layouts/CreateYourPlanTextStep';
import {
  Layout as CreateYourPlanConfirmationStepLayout,
  metaOverrideSet as CreateYourPlanConfirmationStepMetaOverrides,
} from '../Modal/Layouts/CreateYourPlanConfirmationStep';
import { Layout as IncomeTypeStepLayout, metaOverrideSet as incomeTypeStepMetaOverrideSet } from '../Modal/Layouts/IncomeTypeStep';
import {
  Layout as JobEmployerMatchDecisionStepLayout,
  metaOverrideSet as JobEmployerMatchDecisionStepMetaOverrideSet,
} from '../Modal/Layouts/JobEmployerMatchDecisionStep';
import {
  Layout as JobEmployerMatchElectiveSetupStepLayout,
  metaOverrideSet as espMatchElectiveStepMetaOverrideSet,
} from '../Modal/Layouts/JobEmployerMatchElectiveSetupStep';
import {
  Layout as JobEmployerMatchNonElectiveSetupStepLayout,
  metaOverrideSet as JobEmployerMatchNonElectiveSetupStepMetaOverrideSet,
} from '../Modal/Layouts/JobEmployMatchNonElectiveSetupStep';
import {
  Layout as JobEmployerMatchWrongAccountTypeLayout,
  metaOverrideSet as JobEmployerMatchWrongAccountTypeMetaOverrideSet,
} from '../Modal/Layouts/JobEmployerMatchWrongAccountTypeStep';
import {
  Layout as JobEmployerMatchNoAccountStepLayout,
  metaOverrideSet as JobEmployerMatchNoAccountStepMetaOverrideSet,
} from '../Modal/Layouts/JobEmployerMatchNoAccountStep';

import { Layout as EditAccountLayout, metaOverrideSet as editAccountMetaOverrideSet } from '../Modal/Layouts/EditAccount';
import { Layout as RealAssetModalLayout, metaOverrideSet as realAssetMetaOverrideSet } from '../Modal/Layouts/RealAsset';


import {
  Layout as HouseholdFoundationalValuesIntroLayout,
  metaOverrideSet as householdFoundationalValuesIntroMetaOverrideSet,
} from '../Modal/Layouts/HouseholdFoundationalValuesIntroStep';
import {
  Layout as HouseholdFoundationalValuesYouGotThisLayout,
  metaOverrideSet as householdFoundationalValuesYouGotThisMetaOverrideSet,
} from '../Modal/Layouts/HouseholdFoundationalValuesYouGotThisStep';
import {
  Layout as HouseholdFoundationalValuesHowDoYouFeelLayout,
  metaOverrideSet as householdFoundationalValuesHowDoYouFeelMetaOverrideSet,
} from '../Modal/Layouts/HouseholdFoundationalValuesHowDoYouFeelStep';
import {
  Layout as HouseholdFoundationalValuesMoneyAndEmotionsLayout,
  metaOverrideSet as householdFoundationalValuesMoneyAndEmotionsMetaOverrideSet,
} from '../Modal/Layouts/HouseholdFoundationalValuesMoneyAndEmotionsStep';

import {
  Layout as RiskToleranceWelcomeStepLayout,
  metaOverrideSet as RiskToleranceWelcomeStepOverrideSet,
} from '../Modal/Layouts/RiskToleranceWelcomeStep';
import {
  Layout as RiskToleranceResultLayout,
  metaOverrideSet as RiskToleranceResultOverrideSet,
} from '../Modal/Layouts/RiskToleranceResultStep';
import {
  Layout as RiskToleranceManualLayout,
  metaOverrideSet as RiskToleranceManualOverrideSet,
} from '../Modal/Layouts/RiskToleranceManualStep';
import {
  Layout as RiskToleranceBigPicklistQuestionLayout,
  metaOverrideSet as RiskToleranceBigPicklistQuestionOverrideSet,
} from '../Modal/Layouts/RiskToleranceBigPicklistQuestionLayout';
import {
  Layout as OptimalDebtPathStepLayout,
  metaOverrideSet as optimalDebtPathStepOverrideSet,
} from '../Modal/Layouts/OptimalDebtPathStep';
import {
  Layout as OptimalDebtPathLiabilitiesStepLayout,
  metaOverrideSet as optimalDebtPathLiabilitiesStepOverrideSet,
} from '../Modal/Layouts/OptimalDebtPathLiabilitiesStep';
import {
  Layout as PageCompletionSummaryLayout,
  Override as PageCompletionSummaryOverride,
} from '../Modal/Layouts/PageCompletionSummary';
import {
  Layout as FacetPlanStateSponsored529PlanConfigurationEntryLayout,
  metaOverrideSet as defaultFacetPlanStateSponsored529PlanConfigurationEntryLayoutMetaOverrideSet,
} from '../Modal/Layouts/FacetPlanStateSponsored529PlanConfigurationEntry';
import {
  Layout as FillInLiabilitiesStepLayout,
  metaOverrideSet as FillInLiabilitiesOverrideSet,
} from '../Modal/Layouts/FillInLiabilitiesStep';
import {
  Layout as ReviewCreditReportStepLayout,
  overrideSet as reviewCreditReportStepOverrideSet,
} from '../Modal/Layouts/ReviewCreditReportStep';
import { Layout as CreditScoreLayout, overrideSet as CreditScoreOverrideSet } from '../Modal/Layouts/CreditScoreLayout';
import {
  Layout as AccountAssetLinkingLayout,
  metaOverrideSet as AccountAssetLinkingMetaOverrideSet,
} from '../Modal/Layouts/AccountAssetLinking';
import {
  Layout as AccountRelatedRealAssetLayout,
  metaOverrideSet as AccountRelatedRealAssetMetaOverrideSet,
} from '../Modal/Layouts/AccountRelatedRealAsset';
import {
  Layout as ManageFacetPlanRealAssetDetailsStepLayout,
  metaOverrideSet as ManageFacetPlanRealAssetDetailsStepMetaOverrideSet,
} from '../Modal/Layouts/ManageFacetPlanRealAssetDetailsStep';
import {
  Layout as FacetPlanVirtualAccountEditInformationStepLayout,
  metaOverrideSet as FacetPlanVirtualAccountEditInformationStepMetaOverrideSet,
} from '../Modal/Layouts/FacetPlanVirtualAccountEditInformationStep';

import {
  Layout as FacetPlanCustomStrategySetupInfoStepLayout,
  metaOverrideSet as FacetPlanCustomStrategySetupInfoStepMetaOverrideSet,
} from '../Modal/Layouts/FacetPlanCustomStrategySetupInfoStep';
import {
  Layout as CondensedCrudFormTemplate,
  getMetaOverrideSet as getCondensedCrudFormTemplateMetaOverrideSet,
} from '../Modal/Layouts/CondensedCrudFormTemplate';
import {
  Layout as InvestmentApproachesLayout,
  metaOverrideSet as InvestmentApproachesMetaOverrideSet,
} from '../Modal/Layouts/InvestmentApproaches';
import { Layout as TaxDashboardAskAnExpertLayout, metaOverrideSet as taxDashboardAskAnExpertMetaOverrideSet } from '../Modal/Layouts/TaxDashboardAskAnExpert';

const areWeInDO = () => {
  return QueryVal(STEP_LINK_QUERY_PARAM_NAME, '') !== '';
};

// TODO: replace with better solution
const MODAL_SIZE = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

const taxDashboardWizardModalProps = {
  modalSize: MODAL_SIZE.sm,
  noCloseButton: true,
  fixedHeight: false,
  color: 'subtle',
};


export const templateMap = {
  ManagedAccountModelUpdateRequestAggregatePage: {
    page: tc.build(ManagedAccountModelUpdateRequestAggregatePageTemplate),
  },
  DetailList: {
    page: tc.build(WizardStepDetailListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: DetailListLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  AnnualReviewWizardWelcomeStep: {
    page: tc.build(WizardWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  GeneratedView: {
    page: tc.build(SwitchViewTemplate).deprecatedDebouncePageLoads(),
  },
  DoProgressView: {
    page: tc.build(GeneratedViewTemplate).deprecatedDebouncePageLoads(),
  },
  ClientView: {
    page: tc.build(GeneratedViewTemplate).deprecatedDebouncePageLoads(),
  },
  FirstWinView: {
    page: tc.build(GeneratedViewTemplate).deprecatedDebouncePageLoads(),
  },
  PaymentChangeView: {
    page: tc.build(GeneratedViewTemplate).deprecatedDebouncePageLoads(),
  },
  LinkedAccountError: {
    page: tc.build(LinkedAccountErrorViewTemplate).deprecatedDebouncePageLoads(),
  },
  InvestorProfilePage: {
    page: tc.build(InvestorProfilePageTemplate).deprecatedDebouncePageLoads(),
  },
  TaskStatusView: {
    page: tc.build(TaskStatusViewTemplate).deprecatedDebouncePageLoads(),
  },
  LinkingAttempt: {
    page: tc.build(LinkingAttemptsTemplate).deprecatedDebouncePageLoads(),
  },
  AumHouseholdView: {
    page: tc.build(AumHouseholdViewTemplate).deprecatedDebouncePageLoads(),
  },
  annualReviewWelcome: {
    page: tc.build(WizardWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  workflowStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  facetPlanClientView: {
    page: tc.build(WhatIfClientTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  FacetPlanClientViewRedefined: {
    page: tc.build(WhatIfClientRedefinedTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionScenarioDetailsStep: {
    page: tc.build(ScenarioSelectionScenarioDetailsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  facetPlan: {
    page: tc.build(EditFacetPlanTemplate).deprecatedDebouncePageLoads(),
  },
  onboardingQualitativeQuestion: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentObjectivesAccountObjectives: {
    page: tc.build(InvestmentObjectivesAccountReviewTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FQTmplAdminPage: {
    page: tc.build(FQAdminPanel).deprecatedDebouncePageLoads(),
  },
  facetPlanScenarioPage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  ManagedAccountModelUpdateRequestPage: {
    page: tc.build(ManagedAccountModelUpdateRequestPageTemplate).deprecatedDebouncePageLoads(),
  },
  facetPlanProposalPage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  facetPlanArchivePage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  templateManagerPage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  PerformanceCommentaryTimePeriodPage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  PerformanceCommentaryPage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanBookLevelTablePage: {
    page: tc.build(GenericTableTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanPageItemCreate: {
    page: tc.build(WhatIfItemManagementCreationTemplate).deprecatedDebouncePageLoads(),
  },
  facetPlanProposalPreview: {
    page: tc.build(WhatIfProposalPreviewTemplate).deprecatedDebouncePageLoads(),
  },
  facetPlanProposalNextUpReviewPage: {
    page: tc.build(FacetPlanProposalNextUpReviewPageTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanProposalScenarioSelectionIntroPage: {
    page: tc.build(FacetPlanProposalScenarioSelectionIntroPageTemplate).deprecatedDebouncePageLoads(),
  },
  RoadmapExecutiveSummary: {
    page: tc.build(RoadmapExecutiveSummaryTemplate).deprecatedDebouncePageLoads(),
  },
  RoadmapExecutiveSummaryStep: {
    page: tc.build(RoadmapExecutiveSummaryStepTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanVirtualAccountMappingStep: {
    page: tc.build(WhatIfFacetPlanUpdateAccountMappingTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanClickToSyncAccountMapping: {
    page: tc.build(FacetPlanClickToSyncAccountMappingTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanClickToSyncScenarioChangeReview: {
    page: tc.build(FacetPlanClickToSyncReviewChangesTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanVirtualAccountImportStep: {
    page: tc.build(WhatIfFacetPlanUpdateImportAccountsTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanUpdateVirtualAccountsStep: {
    page: tc.build(WhatIfFacetPlanUpdateVirtualAccountsTemplate).deprecatedDebouncePageLoads(),
  },
  annualInvestmentReviewIncomeSalary: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeBonus: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeSelfEmployed: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeSocialSecurity: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeRental: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeInvestment: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeTrust: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeAnnuity: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomePension: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  annualInvestmentReviewIncomeOther: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  onboardingPersonalInformation: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  onboardingFamilyMemberDetail: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  WizardModuleGenericWelcomeStep: {
    page: tc.build(ModuleWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  SelectInstitutionStep: {
    page: tc.build(SelectInstitutionTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      color: areWeInDO() ? undefined : 'subtle',
      Layout: SelectInstitutionStepTemplate,
      metaOverrideSet: SelectInstitutionStepOverride,
    },
  },
  SchedulerStep: {
    page: tc.build(Scheduler).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioSelectionRedefinedScenarioDetailsStep: {
    page: tc.build(ScenarioSelectionRedefinedScenarioDetailsStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStep: {
    page: tc.build(ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedTheYearAheadStep: {
    page: tc.build(ScenarioSelectionRedefinedTheYearAheadStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStep: {
    page: tc.build(ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedTaxStrategyStep: {
    page: tc.build(ScenarioSelectionRedefinedTaxStrategyStepTemplate).deprecatedDebouncePageLoads(),
  },
  ProposalScenarioTaxStrategyDetailsStep: {
    page: tc.build(ProposalScenarioTaxStrategyDetailsStepTemplate).hideNavigation(),
  },
  ScenarioSelectionRedefinedDecisionStep: {
    page: tc.build(ScenarioSelectionRedefinedDecisionStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep: {
    page: tc.build(ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStepContainer).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedPostSelectionNextUpRefreshStep: {
    page: tc.build(ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedPostSelectionNextUpActionsStep: {
    page: tc.build(ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionRedefinedPortfolioUpdatesStep: {
    page: tc.build(ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate).controlsLayoutContext(),
  },
  ScenarioReselectionStep: {
    page: tc.build(ScenarioReselectionStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioSelectionCommonInsightsStep: {
    page: tc.build(ScenarioSelectionCommonInsights).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioSelectionViewInsightsStep: {
    page: tc.build(ScenarioSelectionViewInsightsStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  LinkOrAddAccountsStepDO: {
    page: tc.build(LinkOrAddAccountsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: LinkOrAddAccountsStepLayout,
      metaOverrideSet: LinkOrAddAccountsStepMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'sm',
      fixedHeight: false,
      forceNotFullScreen: false,
    },
  },
  LinkOrAddAccountsStep: {
    page: tc.build(LinkOrAddAccountsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: LinkOrAddAccountsStepLayout,
      metaOverrideSet: LinkOrAddAccountsStepMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'sm',
      fixedHeight: false,
      forceNotFullScreen: false,
    },
  },
  FailedToLinkAccountStepDO: {
    page: tc.build(FailedToLinkTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: FailedToLinkAccountStepLayout,
      metaOverrideSet: FailedToLinkAccountStepMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'sm',
      fixedHeight: false,
    },
  },
  FailedToLinkAccountStep: {
    page: tc.build(FailedToLinkTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: FailedToLinkAccountStepLayout,
      metaOverrideSet: FailedToLinkAccountStepMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'sm',
      fixedHeight: false,
    },
  },
  riskToleranceRetirementAge: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStep: {
    page: tc.build(AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStepTemplate).deprecatedDebouncePageLoads(),
  },
  AnnualInvestmentAllocationReviewStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AnnualInvestmentAllocationReviewConfirmStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  riskToleranceQuestion: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: defaultFDModalMetaOverrideSet,
    },
  },
  riskToleranceResult: {
    page: tc.build(RiskToleranceResultTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: RiskToleranceResultLayout,
      metaOverrideSet: RiskToleranceResultOverrideSet,
    },
  },
  riskToleranceManual: {
    page: tc.build(RiskToleranceManualTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: RiskToleranceManualLayout,
      metaOverrideSet: RiskToleranceManualOverrideSet,
    },
  },
  FinancialInstitutionSuccessRate: {
    page: tc.build(InstitutionSuccessRateTemplate).deprecatedDebouncePageLoads(),
  },
  InvestmentObjectivesWelcomeStep: {
    page: tc.build(ModuleWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  UserSettingsSectionSecurity: {
    page: tc.build(SettingsTemplate).deprecatedDebouncePageLoads(),
  },
  UserSettingsSectionSupport: {
    page: tc.build(SupportTemplate).deprecatedDebouncePageLoads(),
  },
  PaymentStep: {
    page: tc.build(PaymentStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  LeadPage: {
    page: tc.build(LeadPageForm).deprecatedDebouncePageLoads(),
  },
  AnnualReviewWizardCompleteStep: {
    page: tc.build(AnnualInvestmentReviewCompleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfileWelcomeStep: {
    page: tc.build(ModuleWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfileAddressInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfileBasicPersonalInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfilePersonalInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfilePersonalInformationReviewStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfileVisaInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfilePhysicalAddressStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfileMailingAddressStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  InvestmentProfileProvideEmploymentInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentProfileCompleteStep: {
    page: tc.build(InvestmentProfileCompleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfileInvestInESGQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfileInvestmentObjectivesStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfilePhysicalAddressSameAsMailingStep: {
    page: tc.build(WizardBadgeBigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  InvestmentProfileUncommonSituationsStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  AccountOpeningTrustInformationStep: {
    page: tc.build(AccountOpeningTrustInformation).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningTrustAddressInformationStep: {
    page: tc.build(AccountOpeningTrustAddress).hideNavigation(),
  },
  AccountOpeningTrustDocumentsStep: {
    page: tc.build(WizardAttachmentsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountRetitlingSuccessStep: {
    page: tc.build(AccountRetitlingSuccessTemplate).hideNavigation(),
  },
  TrustedContactQuestionStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  TrustedContactInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountAgreementStep: {
    page: tc.build(AccountOpeningAgreementTemplatePicker).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountAgreementV2Step: {
    page: tc.build(AccountOpeningAgreementV2TemplatePicker).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ProfilePage: {
    page: tc.build(ProfilePage).deprecatedDebouncePageLoads(),
  },
  ProfilePageMDC: {
    page: tc.build(ProfilePageMDC).deprecatedDebouncePageLoads(),
  },
  referralPage: {
    page: tc.build(ReferralPage).deprecatedDebouncePageLoads(),
  },
  TaxHomePage: {
    page: tc.build(TaxHomePage),
  },
  TaxFilingPartnerPage: {
    page: tc.build(TaxFilingPartnerPage).hideNavigation(),
  },
  TaxWaitlistPage: {
    page: tc.build(TaxWaitlistPage),
  },
  TaxFilingDashboardPage: {
    page: tc.build(TaxDashboardPage),
  },
  EndorserAgreementPage: {
    page: tc.build(EndorserAgreementPage),
  },
  PlannerAccountApplicationHouseholdStep: {
    page: tc.build(WizardAutoComplete).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardAutoCompletePrefillHouseholdIdLayout,
      metaOverrideSet: WizardAutoCompleteMetaOverrideSet,
      forceFullScreen: true,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  StockExchangeOrFinraAffiliateQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  StockExchangeOrFinraAffiliateInformationStep: {
    page: tc.build(WizardAttachmentsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: Three120LetterLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  FinraAffiliatedDocumentUploadStep: {
    page: tc.build(WizardAttachmentsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentProfileClientUncommonSituationsStep: {
    page: tc.build(InvestmentProfileClientUncommonSituationsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  PlannerAccountApplicationAccountTypeStep: {
    page: tc.build(WizardBigHierarchyMultipicklistControl).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBigHierarchyMultipicklistControlLayout,
      forceFullScreen: true,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  YourRoadmapIsReadyStep: {
    page: tc.build(YourRoadmapIsReadyStepTemplate).hideNavigation(),
  },
  WelcomeToYourRoadmapStep: {
    page: tc.build(WelcomeToYourRoadmapStepTemplate).hideNavigation(),
  },
  RoadmapGoalsByTimeStep: {
    page: tc.build(RoadmapGoalsByTimeStepTemplate).controlsLayoutContext(),
  },
  RoadmapChartStep: {
    page: tc.build(RoadmapChartStepTemplate).hideNavigation(),
  },
  RoadmapGoalsNext12MonthsStep: {
    page: tc.build(RoadmapGoalsNext12MonthsStepTemplate).controlsLayoutContext(),
  },
  RoadmapActionsThisMonthStep: {
    page: tc.build(RoadmapActionsThisMonthStepTemplate).controlsLayoutContext(),
  },
  RoadmapGoalDetailsStep: {
    page: tc.build(RoadmapGoalDetailsStepTemplate).controlsLayoutContext(),
  },
  WhatToDiscussStep: {
    page: tc.build(WhatToDiscussStepTemplate).hideNavigation(),
  },
  MeetingInfoOutroStep: {
    page: tc.build(MeetingInfoOutroStepTemplate).hideNavigation(),
  },
  RoadmapHowToStartStep: {
    page: tc.build(RoadmapHowToStartStepTemplate).hideNavigation(),
  },
  ActionCompletionGreatJobStep: {
    page: tc.build(ActionCompletionGreatJobStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationAccountOwnersStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  PlannerAccountApplicationModelAssignmentStep: {
    page: tc.build(PlannerAccountOpeningModelAssignmentTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: PlannerAccountOpeningModelAssignmentLayout,
      forceFullScreen: true,
      metaOverrideSet: ModelAssignmentOverrideSet,
      modalType: 'legacy',
    },
  },
  AccountOpeningCustodialInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountOpeningDecedentInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationAdditionalConsiderationsStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationFundingInstructionsJustificationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationCompleteStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardCompleteLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  HouseholdAccessJustification: {
    page: tc.build(HouseholdAccessJustificationPageTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  PlannerAccountApplicationAccountObjectivesStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationFundingInstructionsStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountApplicationEsgTalkingPointsStep: {
    page: tc.build(PlannerAccountOpeningESGConfirmationTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: PlannerAccountOpeningModelAssignmentESGConfirmationLayout,
      forceFullScreen: true,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  PlannerAccountTrustRetitlingAccountStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PlannerAccountTrustRetitlingSuccessStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountRetitlingDisclosuresStep: {
    page: tc.build(AccountOpeningAgreementV2TemplatePicker).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FundingInstructionFundingTypeStep: {
    page: tc.build(FundingInstructionsFundingTypeWizardStep).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: FundingInstructionFundingTypeLayout,
      metaOverrideSet: BigPickListTemplateOverrideSet,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  FundingInstructionAchTransfer: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  BadgeStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  RolloverTransferQuestionnaireStep: {
    page: tc.build(DoLQuestionnaireTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: DolQuestionnaireModalTemplate,
      metaOverrideSet: dolMetaOverride,
      modalType: 'legacy',
    },
  },
  RolloverTransferAdditionalDetailsStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: FacetPlanNextUpDoLACATAnswerStepLayout,
      metaOverrideSet: facetPlanNextUpDoLACATAnswerStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  RoadmapDeliverableCustomInsight: {
    modal: {
      Layout: RoadmapDeliverableCustomInsightLayout,
      metaOverrideSet: RoadmapDeliverableCustomInsightMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'sm',
      fixedHeight: false,
      color: 'subtle',
    },
  },
  FundingInstructionRolloverTransferAdditionalInstructions: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: TransferRolloverAdditionalInstructionsOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  FundingInstructionRolloverTransferReasonStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  AcatTransferAdditionalDetailsStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: FacetPlanNextUpDoLACATAnswerStepLayout,
      metaOverrideSet: facetPlanNextUpDoLACATAnswerStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  AcatTransferAdditionalDetailsStepNew: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: FacetPlanNextUpDoLACATAnswerStepLayout,
      metaOverrideSet: facetPlanNextUpDoLACATAnswerStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  UpgradeConfirmationPage: {
    page: tc.build(UpgradeConfirmationPageTemplate),
  },
  RolloverTransferPercentageFeeStep: {
    page: tc.build(WizardAttachmentsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardAttachmentsLayout,
      metaOverrideSet: WizardAttachmentsLayoutMateOverrideSet,
      modalType: 'legacy',
    },
  },
  FundingInstructionAchDepositStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: ACHTransferTemplateOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  FundingInstructionAchWithdrawalStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: ACHTransferTemplateOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  UploadOrSelectFromSecureFilesStep: {
    page: tc.build(UploadOrSelectFromSecureFilesTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: UploadOrSelectFromSecureFilesStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  UploadFileStep: {
    page: tc.build(UploadFileTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: UploadFileStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  SelectFileStep: {
    page: tc.build(SelectFileTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: SelectFileStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  FundingInstructionCompleteStep: {
    page: tc.build(FundingInstructionCompleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: NoopFinishStep,
      forceFullScreen: true,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  PoliticallyExposedQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  YesNoQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: BigPickListLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  MultipleYesNoQuestionsStep: {
    page: tc.build(WizardMutipleYesNoQuestionsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: MultipleYesNoQuestionsLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  SingleOptionalInputStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  ScenarioActivationFundingInstructionsInterstitialStep: {
    page: tc.build(ActivationAccountFundingInstructionsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  PartialRothConversionConsent: {
    page: tc.build(PartialRothConversionConsentTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  SingleRequiredInputStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  PoliticallyExposedInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  PublicCompanyControlQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  BlockMoveManagedAccountStep: {
    page: tc.build(WizardStepTemplate),
  },
  PublicCompanyControlInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  EmployerRequiresDuplicateStatementsQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  EmployerRequiresDuplicateStatementsInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  SubjectToBackupWithholdingsQuestionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: WizardBadgeStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  ScenarioActivationAccountOpeningInterstitialStep: {
    page: tc.build(ScenarioActivationAccountOpeningInterstitialTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FacetPlanScenarioReviewIntroStep: {
    page: tc.build(ClientScenarioIntroPicker).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FacetPlanScenarioReviewScenarioReviewStep: {
    page: tc.build(ClientScenarioReviewLayout).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FacetPlanNoopFinishStep: {
    page: tc.build(DummyTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: DummyLayout,
      modalType: 'invisible',
    },
  },
  FacetPlanClickToSyncConfigurationNoopFinishStep: {
    page: tc.build(DummyTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FacetPlanClickToSyncReviewChangesNoopFinishStep: {
    page: tc.build(DummyTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  NoopFinishStep: {
    page: tc.build(NoopPageTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: NoopFinishStep,
      modalType: 'invisible',
    },
  },
  FacetPlanClientScenarioInsight: {
    page: tc.build(FacetPlanClientScenarioInsightTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ManagedAccountAllocationCleanup: {
    page: tc.build(ManagedAccountAllocationCleanup).deprecatedDebouncePageLoads(),
  },
  FacetPlanCongratulations: {
    page: tc.build(FacetPlanCongratulationsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningWelcomeStep: {
    page: tc.build(ModuleWelcomeStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningTalkToSomeoneStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  AccountOpeningFewMoreThingsStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  AccountOpeningCompleteStep: {
    page: tc.build(InvestmentProfileCompleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningAccountOwnerList: {
    page: tc.build(WizardStepDetailListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningBeneficiaryWelcomeStep: {
    page: tc.build(WizardBadgeStepTemplate).hideNavigation(),
  },
  AccountOpeningBeneficiarySuggestionStep: {
    page: tc.build(WizardStepDetailListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningPrimaryBeneficiarySelectionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningContingentBeneficiarySelectionStep: {
    page: tc.build(BigPickListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountOpeningBeneficiaryPercentageStep: {
    page: tc.build(BeneficiaryDetailListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  PlannerAccountApplicationRiskToleranceStep: {
    page: tc.build(PlannerAccountOpeningRiskToleranceTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: PlannerAccountOpeningRiskTolerance,
      forceFullScreen: true,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  SocialSecurityNumberStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  SocialSecurityNumberWithConfirmationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountOpeningPersonalBeneficiaryInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountOpeningOrganizationBeneficiaryInformationStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  CIPInformationVerificationStep: {
    page: tc.build(CIPInformationVerificationTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  CIPStatusItemDocumentUpload: {
    page: tc.build(CIPStatusItemDocumentUploadTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  CIPFinishStep: {
    page: tc.build(CIPFinishTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  ScenarioActivationAccountOpeningCIPFinishStep: {
    page: tc.build(CIPFinishActivationTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  CIPFixNameStep: {
    page: tc.build(WizardStepTemplate).hideMobileNavigation(),
  },
  CIPFixAddressStep: {
    page: tc.build(WizardStepTemplate).hideMobileNavigation(),
  },
  CIPFixDateOfBirthStep: {
    page: tc.build(WizardStepTemplate).hideMobileNavigation(),
  },
  CIPFixTaxIdentificationStep: {
    page: tc.build(WizardStepTemplate).hideMobileNavigation(),
  },
  CIPDocumentReview: {
    page: tc.build(CIPDocumentReviewTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  ACHTransferSelectAccountStep: {
    page: tc.build(ACHTransferSelectAccountTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  UnlinkApexFundingAccountStep: {
    page: tc.build(ApexFundingAccountUnlinkTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  DeleteApexFundingAccountStep: {
    page: tc.build(ApexFundingAccountDeleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ApexFundingAccountLinkingStep: {
    page: tc.build(ApexFundingAccountSyncTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ManualRolloverStep: {
    page: tc.build(ManualRolloverTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  RolloverConciergeIntroStep: {
    page: tc.build(RolloverConciergeIntroStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ManualRolloverMeetingAlreadyScheduledStep: {
    page: tc.build(ManualRolloverMeetingAlreadyScheduledStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ApexFundingAccountVerificationStep: {
    page: tc.build(ApexFundingAccountVerificationTemplatePicker).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ApexFundingAccountRejectedStep: {
    page: tc.build(ApexFundingAccountRejectedStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ApexFundingAccountLinkingResultStep: {
    page: tc.build(ApexFundingAccountResultTemplate).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: ApexFundingAccountResultStep,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  InvestmentProfileFamilyMemberListStep: {
    page: tc.build(WizardStepDetailListTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentObjectivesHomeTimeHorizonStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  ScenarioActivationManualTransferSubmittedStep: {
    page: tc.build(NonAcatConfirmationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestmentObjectivesFamilyTimeHorizonStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentObjectivesEducationTimeHorizonStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  InvestmentObjectivesMajorLifeEventTimeHorizonStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  AccountProposalReviewStep: {
    page: tc.build(AccountProposalReviewStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  CashAccountProposalStep: {
    page: tc.build(CashAccountProposal).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FeatureToggleHierarchy: {
    page: tc.build(HierarchicalViewTemplate).deprecatedDebouncePageLoads(),
  },
  FacetPlanAssumptionSet: {
    page: tc.build(FacetPlanAssumptionSetTemplate).deprecatedDebouncePageLoads(),
  },
  facetPlanAssumptionSet: {
    page: tc.build(FacetPlanAssumptionSetTemplate).deprecatedDebouncePageLoads(),
  },
  ClientAccountOpeningStartPage: {
    page: tc.build(ClientAccountOpeningStartPageTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ACATInstitutionSelectionStep: {
    page: tc.build(ACATInstitutionSelectionTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AcatTransferFundsStep: {
    page: tc.build(AcatTransferFundsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AcatTransferSubmitStep: {
    page: tc.build(AcatTransferFundsTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountRolloverDetailsStep: {
    page: tc.build(AccountRolloverWizardStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountFundingInstructionsPage: {
    page: tc.build(FundingInstructionsPageTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  GoalsPage: {
    page: tc.build(GoalsPage),
  },
  MissionControl: {
    page: tc.build(MissionControl).deprecatedDebouncePageLoads(),
  },
  CapitalizeRolloverAccountsStatusStep: {
    page: tc.build(CapitalizeRolloverAccountStatusStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  CapitalizeRolloverIntroStep: {
    page: tc.build(CapitalizeRolloverIntroStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  CapitalizeRolloverWebviewStep: {
    page: tc.build(CapitalizeRolloverWebviewStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  TransferCompleteStep: {
    page: tc.build(TransferCompleteTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  NonAcatConfirmationStep: {
    page: tc.build(NonAcatConfirmationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ACHTransferDepositStep: {
    page: tc.build(ACHTransferTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ACHTransferWithdrawalStep: {
    page: tc.build(ACHTransferTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ACHTransferIRAContributionStep: {
    page: tc.build(ACHTransferTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ACHTransferIRADistributionStep: {
    page: tc.build(ACHTransferTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScheduledCashJournal: {
    page: tc.build(ScheduledCashJournal).deprecatedDebouncePageLoads().hideNavigation(),
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  ScheduledCashJournalSelectDestinationAccountStep: {
    page: tc.build(ScheduledCashJournal).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FundingInstructionCashJournalDestinationAccountSelectionStep: {
    page: tc.build(ScheduledCashJournal).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FundingInstructionCashJournalSetupStep: {
    page: tc.build(ScheduledCashJournal).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScheduledCashJournalSetupStep: {
    page: tc.build(ScheduledCashJournalSetup).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScheduledCashJournalSetupCompleteStep: {
    page: tc.build(ScheduledCashJournalCompleteStep).deprecatedDebouncePageLoads().hideNavigation(),
  },
  FAQGroup: {
    page: tc.build(FAQGroupTemplate).deprecatedDebouncePageLoads(),
  },
  AccountTransferSetupSelectAccountTypeStep: {
    page: tc.build(SelectTransferTypeTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountTransferSetupSelectTransferTypeStep: {
    page: tc.build(AccountTransferSetupSelectTransferTypeTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  SelectHouseholdStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  SelectClientStep: {
    page: tc.build(WizardStepTemplate),
  },
  MoveManagedAccountConfirmationStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      primaryActionLabel: 'Confirm and Move Accounts',
      overrideSet: BaseWizardStepOverride,
    })).deprecatedDebouncePageLoads(),
  },
  MoveManagedAccountCompletedStep: {
    page: tc.build(WizardCompleteStepTemplate).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountSelectHouseholdStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountSelectNewHouseholdStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountSelectNewClientStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountReviewStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountCompletedStep: {
    page: tc.build(WizardCompleteStepTemplate).deprecatedDebouncePageLoads(),
  },
  OverrideHouseholdAndClientForManagedAccountSelectAccountStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      overrideSet: WizardAutoCompleteMetaOverrideSet,
    })).deprecatedDebouncePageLoads(),
  },
  DesiredOutcomesSummaryPage: {
    page: tc.build(DesiredOutcomesSummaryPageTemplate).deprecatedDebouncePageLoads(),
  },
  HouseholdMembershipPage: {
    page: tc.build(ProfileTemplate).deprecatedDebouncePageLoads(),
  },
  paymentDetailsPage: {
    page: tc.build(PaymentInfoProfileSubpage).deprecatedDebouncePageLoads(),
  },
  billingDetailsPage: {
    page: tc.build(BillingDetailsProfileSubpage).deprecatedDebouncePageLoads(),
  },
  estatePlanningPage: {
    page: tc.build(EstatePlanningProfileSubpage).deprecatedDebouncePageLoads(),
  },
  EstatePlanningManagementPage: {
    page: tc.build(EstatePlanningManagementPageTemplate).deprecatedDebouncePageLoads(),
  },
  EstatePlanningRecommendationBasicInformationStep: {
    page: tc.build(EstatePlanningRecommendationBasicInformationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQualificationStep: {
    page: tc.build(EstatePlanningRecommendationQualificationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQualificationFailedStep: {
    page: tc.build(EstatePlanningRecommendationQualificationFailedStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQualificationFailedConfirmationStep: {
    page: tc.build(EstatePlanningRecommendationQualificationFailedConfirmationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQualificationSuccessStep: {
    page: tc.build(EstatePlanningRecommendationQualificationSuccessStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQuizQuestionsStep: {
    page: tc.build(EstatePlanningRecommendationQuizQuestionsStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationQuizRecommendationStep: {
    page: tc.build(EstatePlanningRecommendationQuizRecommendationStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  EstatePlanningRecommendationBuyStep: {
    page: tc.build(EstatePlanningRecommendationBuyStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  TaxFilingBuyStep: {
    page: tc.build(TaxFilingPurchaseTemplate),
  },
  TaxFilingPurchaseCompleteStep: {
    page: tc.build(ProductPurchaseSuccessStepTemplate).hideNavigation(),
  },
  EstatePlanningRecommendationPurchasedStep: {
    page: tc.build(ProductPurchaseSuccessStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  CancelMembershipPage: {
    page: tc.build(CancelMembershipSubpage).deprecatedDebouncePageLoads(),
  },
  linkedInstitution: {
    page: tc.build(RedirectTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  clientDashboard: {
    page: tc.build(RedirectTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  user: {
    page: tc.build(RedirectTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  RoadmapExplorer: {
    page: tc.build(RoadmapExplorerPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewIntroToGoalThresholdsStep: {
    page: tc.build(GuidedHouseholdReviewIntroToGoalThresholdsPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewGoalsWithThresholdsStep: {
    page: tc.build(GuidedHouseholdReviewGoalsWithThresholdsPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewIntroStep: {
    page: tc.build(GuidedHouseholdReviewIntroPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewGoalPriorityStep: {
    page: tc.build(GuidedHouseholdReviewGoalPriorityPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewFamilyStep: {
    page: tc.build(GuidedHouseholdReviewFamilyPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewFoundationalGoalsStep: {
    page: tc.build(GuidedHouseholdReviewFoundationalGoalsPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewGoalListStep: {
    page: tc.build(GuidedHouseholdReviewGoalListPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewOwnVsOweStep: {
    page: tc.build(GuidedHouseholdReviewOwnVsOwePageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewIncomeStep: {
    page: tc.build(GuidedHouseholdReviewCashFlowPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewExpensesStep: {
    page: tc.build(GuidedHouseholdReviewCashFlowPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewFutureIncomeAndExpensesStep: {
    page: tc.build(GuidedHouseholdReviewFutureIncomeAndExpensesPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewOutroStep: {
    page: tc.build(GuidedHouseholdReviewOutroPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewLeversTransitionStep: {
    page: tc.build(GuidedHouseholdReviewLeversTransitionPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewMoneyToWorkWithStep: {
    page: tc.build(GuidedHouseholdReviewCashFlowPageTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewOutroHowWeBringThisToLifeStep: {
    page: tc.build(GuidedHouseholdReviewOutroHowWeBringThisToLifeTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewOutroOpportunityForHeadStartStep: {
    page: tc.build(GuidedHouseholdReviewOutroForHeadStartTemplate).controlsLayoutContext(),
  },
  GuidedHouseholdReviewOutroScheduleStep: {
    page: tc.build(GuidedHouseholdReviewOutroScheduleTemplate).controlsLayoutContext(),
  },
  Pm2JourneyMemberQuestionsChecklistStep: {
    page: tc.build(PM2JourneyMemberQuestionsChecklistTemplate).controlsLayoutContext(),
  },
  Pm2JourneyMemberQuestionsChecklistRecapStep: {
    page: tc.build(PM2JourneyMemberQuestionsChecklistTemplate).controlsLayoutContext(),
  },
  Pm2JourneyIntroOverviewStep: {
    page: tc.build(PM2JourneyIntroOverviewPageTemplate).controlsLayoutContext(),
  },
  Pm2JourneyIntroOverviewRecapStep: {
    page: tc.build(PM2JourneyIntroOverviewPageTemplate).controlsLayoutContext(),
  },
  Pm2JourneyScheduleMeetingLaterStep: {
    page: tc.build(PM2JourneyScheduleMeetingLaterPageTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingIntroStep: {
    page: tc.build(PM2JourneyInvestingTidbitsTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingKeepMoreStep: {
    page: tc.build(PM2JourneyInvestingImageScreenTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingLongTermDisciplineStep: {
    page: tc.build(PM2JourneyInvestingImageScreenTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingRiskVsReturnStep: {
    page: tc.build(PM2JourneyInvestingImageScreenTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingYourPlanIncludesStep: {
    page: tc.build(PM2JourneyInvestingTidbitsTemplate).controlsLayoutContext(),
  },
  Pm2JourneyInvestingYourPlanAlsoIncludesStep: {
    page: tc.build(PM2JourneyInvestingTidbitsTemplate).controlsLayoutContext(),
  },
  PM2JourneyPathExplorerExit: {
    modal: {
      Layout: PM2JourneyPathExplorerExit,
      modalSize: MODAL_SIZE.sm,
      metaOverrideSet: PM2JourneyPathExplorerExitMetaOverrideSet,
      fixedHeight: false,
    },
  },
  Pm2JourneyRoadmapAdjustmentDiffStep: {
    page: tc.build(PM2JourneyRoadmapAdjustmentDiffTemplate).controlsLayoutContext(),
  },
  AccountOpeningV2AccountAgreementStep: {
    page: tc.build(AccountOpeningV2AccountAgreementStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2FinishStep: {
    page: tc.build(AccountOpeningV2FinishStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2PendingStep: {
    page: tc.build(AccountOpeningV2PendingStep).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2OpeningTakingTooLongStep: {
    page: tc.build(AccountOpeningV2OpeningTakingTooLongStepTemplate).deprecatedDebouncePageLoads(),
  },
  accountCreationRequest: {
    page: tc.build(RedirectTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  PlannerAccountApplicationAccountInformationStep: {
    page: tc.build(PlannerAccountOpeningAccountInformationTemplate).deprecatedDebouncePageLoads(),
    modal: {
      Layout: PlannerAccountOpeningAccountInformationLayout,
      metaOverrideSet: PlannerAccountOpeningAccountInformationOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  creditCardPaymentMethodPage: {
    page: tc.build(AddPaymentMethodProfileSubpage).deprecatedDebouncePageLoads(),
  },
  client: {
    page: tc.build(TemporaryPersonalAndFamilySubpage).deprecatedDebouncePageLoads(),
    modal: {
      Layout: ClientLayout,
      metaOverrideSet: ClientMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  StartKnowYourCustomerIdentityVerificationStep: {
    page: tc.build(StartKnowYourCustomerVerificationTemplate).deprecatedDebouncePageLoads(),
  },
  KYCIntroStep: {
    page: tc.build(KYCIntroStepTemplate).deprecatedDebouncePageLoads(),
    modal: {
      Layout: KYCIntroStepLayout,
      metaOverrideSet: KYCIntroStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  AccountOpeningV2ProposalStep: {
    page: tc.build(AccountOpeningV2ProposalStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2KYCIntroStep: {
    page: tc.build(AccountOpeningV2KYCIntroStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2KYCFailureNotLockedOut: {
    page: tc.build(KYCIntroStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2KYCLockedOut: {
    page: tc.build(KYCIntroStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2BeneficiaryDetailStep: {
    page: tc.build(AccountOpeningV2BeneficiaryDetailStep).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2BeneficiaryIntroStep: {
    page: tc.build(AccountOpeningV2BeneficiaryIntroStep).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2TrustedContactIntroStep: {
    page: tc.build(AccountOpeningV2TrustedContactIntroStep).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2BeneficiaryAllocationsStep: {
    page: tc.build(AccountOpeningV2BeneficiaryAllocationsStep).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2KYCFailureNotLockedOutStep: {
    page: tc.build(AccountOpeningV2KYCFailureNotLockedOutStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2KYCLockedOutStep: {
    page: tc.build(AccountOpeningV2KYCLockedOutStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2WaitStep: {
    page: tc.build(AccountOpeningV2WaitStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2WrongPersonStep: {
    page: tc.build(AccountOpeningV2WrongPersonStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningKYCFailStep: {
    page: tc.build(AccountOpeningKYCFailStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningPersonalInformationMissingFromKYCStep: {
    page: tc.build(WizardStepTemplate),
  },
  AccountOpeningWaitingOnOtherPersonKYCStep: {
    page: tc.build(WizardStepTemplate),
  },
  AccountOpeningV2UncommonSituationsStep: {
    page: tc.build(AccountOpeningV2UncommonSituationsStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2UncommonSituationsUploadStep: {
    page: tc.build(AccountOpeningV2UncommonSituationsUploadStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountOpeningV2PersonalInformationStep: {
    page: tc.build(AccountOpeningV2PersonalInformationStepTemplate).deprecatedDebouncePageLoads(),
  },
  CompletedKnowYourCustomerIdentityVerificationStep: {
    page: tc.build((props) => WizardTemplateWithMetaOverride({
      ...props,
      primaryActionLabel: 'Exit',
      overrideSet: BaseWizardStepOverride,
    })).deprecatedDebouncePageLoads(),
  },
  EmailVerificationSentStep: {
    page: tc.build(EmailVerificationSentStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  accountDebitPaymentMethodPage: {
    page: tc.build(AccountDebitDisclaimerProfileSubpage).deprecatedDebouncePageLoads(),
  },
  ManagedAccountPage: {
    page: tc.build(ManagedAccountPageTemplate).deprecatedDebouncePageLoads(),
  },
  messagesPage: {
    page: tc.build(MessagesPage).deprecatedDebouncePageLoads(),
  },
  PlannerTransitionHouseholdsPage: {
    page: tc.build(PlannerTransitionHouseholdTemplate).deprecatedDebouncePageLoads(),
  },
  TransitionsDashboardPage: {
    page: tc.build(TransitionsDashboardPageTemplate).deprecatedDebouncePageLoads(),
  },
  TaxDiagnosticPlannerPage: {
    page: tc.build(TaxDiagnosticPlannerPageTemplate).deprecatedDebouncePageLoads(),
  },
  ScenarioSelectionIntroStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  ScenarioSelectionChoosePathStep: {
    page: tc.build(WizardStepTemplate).hideNavigation(),
  },
  ScenarioActivationQuestionStep: {
    page: tc.build(ScenarioActivationQuestionStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioReviewScheduledTransfersToDeleteStep: {
    page: tc.build(ScenarioReviewScheduledTransfersToDeleteStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioReviewPostScheduledTransferDeletionStep: {
    page: tc.build(ScenarioReviewScheduledTransfersToDeleteStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioActivationAutomatedTransferScheduledStep: {
    page: tc.build(ScenarioActivationAutomatedTransferScheduledStepTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ScenarioActivationDeclineConfirmationStep: {
    page: tc.build(ScenarioActivationDeclineConfirmation).deprecatedDebouncePageLoads().hideNavigation(),
  },
  file: {
    page: tc.build(RedirectTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  AccountDebitConfirmStep: {
    page: tc.build(AccountDebitConfirmStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountDebitSuccessStep: {
    page: tc.build(AccountDebitSuccessStepTemplate).deprecatedDebouncePageLoads(),
  },
  AccountDebitFinishStep: {
    page: tc.build(AccountDebitFinishStepTemplate).deprecatedDebouncePageLoads(),
  },
  ConnectionPage: {
    page: tc.build(ConnectionPageTemplate).deprecatedDebouncePageLoads(),
  },
  CashFlowPX: {
    page: tc.build(CashFlowPageTemplate).deprecatedDebouncePageLoads(),
  },
  CashFlowMDC: {
    page: tc.build(CashFlowMDCPageTemplate).deprecatedDebouncePageLoads(),
  },
  PlanSummaryPage: {
    page: tc.build(PlanSummaryPageContainerTemplate).deprecatedDebouncePageLoads(),
  },
  NMARSRequestsEmpty: {
    page: tc.build(NMARSEmptyPageTemplate).deprecatedDebouncePageLoads(),
  },
  NMARSRequestsPage: {
    page: tc.build(NMARSRequestsPageTemplate).deprecatedDebouncePageLoads(),
  },
  ConnectionPageEmpty: {
    page: tc.build(SimpleHeroPaperEmptyPageWithoutRefreshTemplate).deprecatedDebouncePageLoads(),
  },
  CashFlowPXEmpty: {
    page: tc.build(SimpleHeroPaperEmptyPageTemplate).deprecatedDebouncePageLoads(),
  },
  HouseholdBalanceSheet: {
    page: tc.build(HouseholdBalanceSheetPageTemplate).deprecatedDebouncePageLoads(),
  },
  HouseholdBalanceSheetEmpty: {
    page: tc.build(SimpleHeroPaperEmptyPageTemplate).deprecatedDebouncePageLoads(),
  },
  // TODO: remove these PX versions, since now they're not specific to PX anymore
  HouseholdBalanceSheetPX: {
    page: tc.build(HouseholdBalanceSheetPageTemplate).deprecatedDebouncePageLoads(),
  },
  HouseholdBalanceSheetPXEmpty: {
    page: tc.build(SimpleHeroPaperEmptyPageTemplate).deprecatedDebouncePageLoads(),
  },
  ClientDashboardPage: {
    page: tc.build(ClientDashboardPageTemplate).deprecatedDebouncePageLoads(),
    modal: {
      Layout: NavigateToPage,
      modalType: 'legacy',
    },
  },
  MemberDashboard: {
    page: tc.build(MemberDashboard).deprecatedDebouncePageLoads(),
  },
  TaxDiagnosticTaxStrategiesSummaryStep: {
    page: tc.build(TaxDiagnosticTaxStrategiesSummaryStep).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticContextBoostSavingsStep: {
    page: tc.build(TaxDiagnosticContextStep).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticContextKeepMoreStep: {
    page: tc.build(TaxDiagnosticContextStep).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticContextLowerTaxesStep: {
    page: tc.build(TaxDiagnosticContextStep).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticBoostSavingsIntroStep: {
    page: tc.build(TaxDiagnosticModuleIntroStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticKeepMoreIntroStep: {
    page: tc.build(TaxDiagnosticModuleIntroStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticLowerTaxesIntroStep: {
    page: tc.build(TaxDiagnosticModuleIntroStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticMegaBackdoorRoth401KStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseMegaBackdoorRoth401KStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticIRASavingsStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticIRASavingsSplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseIRASavingsStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseIRASavingsSplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticEmployerSponsoredPlanStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticEmployerSponsoredPlanSplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseEmployerSponsoredPlanStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseEmployerSponsoredPlanSplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticHSAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseHSAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticFSAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseFSAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticEducationDeductionStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticEducation529PlanStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticCarryForwardLossesStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticRealizingGainsStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticConvertToRothStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticLifetimeLearningCreditStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticStudentLoanInterestDeductionStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticChildTaxCreditStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticCleanVehicleCreditStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticQualifiedAdoptionExpensesCreditStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAmericanOpportunityCreditStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAuditMistakeStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAuditRMDStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAuditHSAand529DeductionsMissedStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAudit1099Step: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticAudit8606ForRothStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSimpleIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSimpleIRASplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseSimpleIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseSimpleIRASplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSepIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseSepIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticInheritedIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticInheritedIRASplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseInheritedIRAStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseInheritedIRASplitStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticDeferredCompStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticSpouseDeferredCompStep: {
    page: tc.build(TaxDiagnosticQuestionStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  TaxDiagnosticNextStepsStep: {
    page: tc.build(TaxDiagnosticNextStepsStepTemplate).deprecatedDebouncePageLoads().hideMobileNavigation(),
  },
  InvestingMindsetStep: {
    page: tc.build(OnboardingInvestmentProfileInvestingMindsetTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  InvestingToolboxStep: {
    page: tc.build(OnboardingInvestmentProfileInvestingToolboxTemplate).deprecatedDebouncePageLoads().hideNavigation(),
  },
  ManagedAccountDocumentsPage: {
    page: tc.build(ManagedAccountDocumentsPage),
  },
  facetPlanView: {
    page: tc.build(WhatIfTemplate),
  },
  simpleActionItem: {
    modal: {
      Layout: SimpleActionItemLayout,
      metaOverrideSet: SimpleActionItemMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  plannerTransitionHousehold: {
    modal: {
      Layout: PlannerTransitionHouseholdLayout,
      metaOverrideSet: PlannerTransitionHouseholdMetaOverrideSet,
      modalSize: MODAL_SIZE.md,
      modalType: 'legacy',
    },
  },
  TotpRegistration: {
    modal: {
      Layout: TotpRegistrationLayout,
      metaOverrideSet: TotpRegistrationOverrideSet,
      modalType: 'legacy',
    },
  },
  ManualMessageRouting: {
    modal: {
      Layout: ManualMessageRoutingLayout,
      metaOverrideSet: ManualMessageRoutingOverrideSet,
      modalSize: MODAL_SIZE.md,
      fixedHeight: false,
    },
  },
  SmsPhoneNumber: {
    modal: {
      Layout: SmsPhoneNumberLayout,
      metaOverrideSet: SmsPhoneNumberOverrideSet,
      modalType: 'legacy',
    },
  },
  SmsRegistration: {
    modal: {
      Layout: SmsRegistrationLayout,
      metaOverrideSet: SmsRegistrationOverrideSet,
      modalType: 'legacy',
    },
  },
  SmsCode: {
    modal: {
      Layout: SmsCodeLayout,
      metaOverrideSet: SmsCodeOverrideSet,
      modalType: 'legacy',
    },
  },
  AuthenticationFactor: {
    modal: {
      Layout: AuthenticationFactorLayout,
      metaOverrideSet: AuthenticationFactorOverrideSet,
      modalType: 'legacy',
    },
  },
  EstatePlanningStatusStep: {
    modal: {
      fixedHeight: false,
      closeOnBackdropClick: true,
      Layout: EstatePlanStatusStepLayout,
      metaOverrideSet: EstatePlanStatusStepMetaOverrideSet,
    },
  },
  EstatePlanningNextStepDependingOnStatusStep: {
    modal: {
      fixedHeight: false,
      closeOnBackdropClick: true,
      Layout: EstatePlanningNextStepDependingOnStatusLayout,
      metaOverrideSet: EstatePlanningNextStepDependingOnStatusMetaOverrideSet,
    },
  },
  UserPassword: {
    modal: {
      Layout: UserPasswordLayout,
      metaOverrideSet: UserPasswordOverrideSet,
      modalType: 'legacy',
    },
  },
  featureToggle: {
    modal: {
      Layout: FeatureToggleLayout,
      metaOverrideSet: featureToggleMetaOverrideSet,
      modalSize: 'md',
    },
  },
  template: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayoutWithDelete,
      metaOverrideSet: TemplateOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlan: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: whatIfMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  PlannerGuide: {
    modal: {
      Layout: PlannerGuideLayout,
      metaOverrideSet: PlannerGuideMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'lg',
      fixedHeight: false,
      color: 'subtle',
    },
  },
  FacetPlanAssumptionByDateEntry: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayoutWithDelete,
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  GenericStrategyStartDateStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(GenericStrategyStartDateStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalType: 'legacy',
    },
  },
  RetirementGetToMatchStrategyIncomeSelectionStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(RetirementPlanMatch),
      metaOverrideSet: RetirementPlanMatchOverrideSet,
      modalType: 'legacy',
    },
  },
  DefineTargetRetirementOutcomeBackdoorIRAStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(DefineTarget401KInvestmentStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  DefineTargetMBR401KStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(DefineTarget401KInvestmentStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanGeneralSavingsOutcomeDefineTargetFundingLevelStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(DefineTarget401KInvestmentStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanChooseBrokerageTargetStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(DefineTarget401KInvestmentStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanSetContributionAmountGenericStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(DefineTarget401KInvestmentStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  DefineTarget401KInvestmentStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanRetirementTargetStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  DefineTargetRoth401KInvestmentStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanRetirementTargetStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  RetirementIRA1ToMaxStrategyDefineTargetStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanRetirementTargetStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  RetirementRothIRAStrategyDefineTargetStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanRetirementTargetStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlan403BStrategyContributionDetailsStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlan403BStrategyContributionDetailsStep),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  AddNewInstitution: {
    modal: {
      Layout: AddNewInstitutionLayout,
      metaOverrideSet: AddNewInstitutionMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'lg',
      fixedHeight: false,
      color: 'subtle',
      forceNotFullScreen: true,
    },
  },
  FinancialInstitutionConnection: {
    modal: {
      Layout: FinancialInstitutionConnectionLayout,
      metaOverrideSet: FinancialInstitutionConnectionMetaOverrideSet,
      closeOnBackdropClick: false,
      modalSize: 'lg',
      fixedHeight: false,
      color: 'subtle',
    },
  },
  FacetPlanOutcomeWizardNavigation: {
    modal: {
      Layout: OutcomeLauncher,
      metaOverrideSet: OutcomeLauncherOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  FacetPlanStrategyWizardNavigation: {
    modal: {
      Layout: StrategyLauncher,
      metaOverrideSet: StrategyLaunderOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanStateSponsored529PlanConfigurationByDateEntry: {
    modal: {
      Layout: FacetPlanStateSponsored529PlanConfigurationEntryLayout,
      metaOverrideSet: defaultFacetPlanStateSponsored529PlanConfigurationEntryLayoutMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanStrategySelectionStep: {
    modal: {
      Layout: StrategyLauncher,
      metaOverrideSet: StrategyLaunderOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  ScheduledAchTransferSummary: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  ManagedAccountTransaction: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  managedAccountTransaction: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  achTransferSummary: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  acatTransferSummary: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  CashJournal: {
    modal: {
      Layout: TransactionDetails,
      metaOverrideSet: TransactionDetailsMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  AccountRelatedRealAsset: {
    modal: {
      Layout: AccountRelatedRealAssetLayout,
      metaOverrideSet: AccountRelatedRealAssetMetaOverrideSet,
    },
  },
  AccountAssetLink: {
    modal: {
      Layout: AccountAssetLinkingLayout,
      metaOverrideSet: AccountAssetLinkingMetaOverrideSet,
    },
  },
  PlannerTransitionSegmentKey: {
    modal: {
      Layout: PlannerTransitionSegmentKey,
      metaOverrideSet: PlannerTransitionSegmentKeyOverrideSet,
      modalSize: MODAL_SIZE.sm,
      modalType: 'legacy',
    },
  },
  FacetPlanStrategyResetConfirmationStep: {
    modal: {
      Layout: StrategyResetConfirmation,
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEmergencyFundMonthlyExpenseReviewStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(EmergencyFundOutcomeExpenseReviewStepLayout),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  EmergencyFundOutcomeSummaryStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(EmergencyFundOutcomeSummaryStepLayout),
      metaOverrideSet: EmergencyFundOutcomeSummaryStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanVirtualAccountSetupStep: {
    modal: {
      Layout: VirtualAccountFlowLayout,
      metaOverrideSet: VirtualAccountFlowMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEducationFund529Plan80ChooseAccountStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanCustomFundingStrategyVirtualAccountSelectionStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanSelectMultipleVirtualAccountsGenericStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  MinPaymentStrategyAccountSetup: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanStrategy: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanChooseBrokerageAccountsStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: AccountSelectionStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  ModelChangeEventsPage: {
    modal: {
      Layout: ModelChangeEventsPage,
      metaOverrideSet: ModelChangeEventsPageMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  FAQ: {
    modal: {
      Layout: FAQ,
      metaOverrideSet: FAQMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  NoopFinishStepDO: {
    modal: {
      Layout: NoopFinishStep,
      modalType: 'invisible',
    },
  },
  FacetPlanChooseStartEndDateStep: {
    modal: {
      Layout: FacetPlanChooseStartEndDateStepLayout,
      metaOverrideSet: FacetPlanChooseStartEndDateStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanChooseStartDateStep: {
    modal: {
      Layout: FacetPlanChooseStartEndDateStepLayout,
      metaOverrideSet: FacetPlanChooseStartEndDateStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanGeneralSavingsOutcomeGeneralParametersStep: {
    modal: {
      Layout: GeneralSavingsOutcomeGeneralParametersStepLayout,
      metaOverrideSet: GeneralSavingsOutcomeGeneralParametersStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEducationOutcomeSummaryStep: {
    modal: {
      Layout: FacetPlanEducationOutcomeSummaryStepLayout,
      metaOverrideSet: FacetPlanEducationOutcomeSummaryStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  AvalancheDebtStrategySetupStep: {
    modal: {
      Layout: StartEndAndMonths,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanDebtSnowballDefineParametersStep: {
    modal: {
      Layout: StartEndAndMonths,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanIncome: {
    modal: {
      Layout: FacetPlanAddIncome,
      metaOverrideSet: FacetPlanAddIncomeOverrideSet,
      modalSize: MODAL_SIZE.lg,
    },
  },
  FacetPlanExpense: {
    modal: {
      Layout: AddFacetPlanExpense,
      metaOverrideSet: FacetPlanAddExpenseOverrideSet,
      modalType: 'legacy',
    },
  },
  AddFacetPlanExpenseStep: {
    modal: {
      Layout: AddFacetPlanExpenseStep,
      metaOverrideSet: FacetPlanAddExpenseOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanBalanceTransfer: {
    modal: {
      Layout: AddFacetPlanBalanceTransfer,
      metaOverrideSet: FacetPlanAddBalanceTransferOverrideSet,
      modalType: 'legacy',
    },
  },
  ManageFacetPlanVirtualAccountBalanceTransferDetailsStep: {
    modal: {
      Layout: AddFacetPlanBalanceTransferStep,
      metaOverrideSet: FacetPlanAddBalanceTransferOverrideSet,
      modalType: 'legacy',
    },
  },
  AssetMissingInformationStep: {
    modal: {
      Layout: AccountMissingInformationTemplate,
      metaOverrideSet: FDWizardModalWrapperOverrides,
      modalSize: MODAL_SIZE.sm,
    },
  },
  MissingAccountsAndRealAssetsStep: {
    modal: {
      Layout: MissingAccountsAndRealAssets,
      metaOverrideSet: MissingAccountsAndRealAssetOverride,
    },
  },
  MissingRealAssetDetailStep: {
    modal: {
      Layout: MissingRealAssetsDetailsTemplate,
      metaOverrideSet: FDWizardModalWrapperOverrides,
    },
  },
  LiabilityMissingInformationStep: {
    modal: {
      Layout: AccountMissingInformationTemplate,
      modalSize: MODAL_SIZE.sm,
    },
  },
  FillInAssetsStep: {
    modal: {
      Layout: FillInLiabilitiesStepLayout,
      metaOverrideSet: FillInLiabilitiesOverrideSet,
      fixedHeight: false,
    },
  },
  FillInLiabilitiesStep: {
    modal: {
      Layout: FillInLiabilitiesStepLayout,
      metaOverrideSet: FillInLiabilitiesOverrideSet,
      fixedHeight: false,
    },
  },
  ManagedAccountAllocation: {
    modal: {
      Layout: ManagedAccountAllocationCleanupDialog,
      metaOverrideSet: ManagedAccountAllocationCleanupDialogOverride,
      modalSize: MODAL_SIZE.lg,
      modalType: 'legacy',
    },
  },
  ManagedAccountModelUpdateRequestAssignedToPlanner: {
    modal: {
      Layout: ManagedAccountModelUpdateRequestDialog,
      metaOverrideSet: BaseOverride,
      forceFullScreen: true,
      limitedMaxHeight: true,
      onlyRenderLayout: true,
      modalType: 'legacy',
    },
  },
  ManagedAccountModelUpdateRequestAssignedToOps: {
    modal: {
      Layout: ManagedAccountModelUpdateRequestDialog,
      metaOverrideSet: BaseOverride,
      forceFullScreen: true,
      limitedMaxHeight: true,
      onlyRenderLayout: true,
      modalType: 'legacy',
    },
  },
  FacetPlanScenarioActivationConfirmation: {
    modal: {
      Layout: FacetPlanScenarioActivationConfirmation.Layout,
      modalSize: MODAL_SIZE.xs,
      forceNotFullScreen: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEducationWithdrawalSetupStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: FacetPlanCustomDebtStackRankStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanCustomDebtStackRankStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: FacetPlanCustomDebtStackRankStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanCustomDebtGeneralParameterStep: {
    modal: {
      Layout: StartEndAndMonths,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  RetirementOutcomeConfirmAgeStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: EducationOutcomeConfirmAgeStepOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  EducationOutcomeConfirmAgeStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: EducationOutcomeConfirmAgeStepOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanOutcomeQuickEditRetirement: {
    modal: {
      Layout: FacetPlanOutcomeQuickEditRetirementLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditRetirementStepOverride,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanEmergencyFundStageInfoStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanEmergencyFundStageInfoWizardLayout),
      metaOverrideSet: WhatIfBaseOverride,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanOutcomeQuickEditGeneralSavings: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: DefaultWithCloseAndRefreshStepOverride,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanOutcomeQuickEditDebt: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: DefaultWithCloseAndRefreshStepOverride,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  OutcomeAccountSelection: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditGoalPropertyMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanOutcomeQuickEditGoalProperty: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditGoalPropertyMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanPropertyGoalBuyActionQuickEdit: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditGoalPropertyMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanPropertyGoalSellActionQuickEdit: {
    modal: {
      Layout: DefaultWithCloseAndRefreshStepLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditGoalPropertyMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanOutcomeQuickEditEducation: {
    modal: {
      Layout: FacetPlanOutcomeQuickEditEducationLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditEducationMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanOutcomeQuickEditEmergencyFund: {
    modal: {
      Layout: FacetPlanOutcomeQuickEditEmergencyFundLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditEmergencyFundMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  FacetPlanOutcomeQuickEditEmergencyFundWithStages: {
    modal: {
      Layout: FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout,
      metaOverrideSet: FacetPlanOutcomeQuickEditEmergencyFundWithStagesMetaOverrideSet,
      modalType: 'drawer',
      variant: 'persistent',
    },
  },
  EstatePlanRequestStep: {
    modal: {
      Layout: EstatePlanRequestStepLayout,
      metaOverrideSet: EstatePlanRequestStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  EstatePlanningBuyIntroStep: {
    modal: {
      Layout: EstatePlanningBuyIntroStepLayout,
      metaOverrideSet: EstatePlanningBuyIntroMetaOverride,
      modalType: 'legacy',
    },
  },
  EstatePlanningBuyPaymentStep: {
    modal: {
      Layout: EstatePlanningBuyPaymentStep,
      modalType: 'legacy',
    },
  },
  EstatePlanningBuySuccessStep: {
    modal: {
      Layout: EstatePlanningBuySuccessStepLayout,
      metaOverrideSet: EstatePlanningBuySuccessMetaOverride,
      modalType: 'legacy',
    },
  },
  EstatePlanningBuyLearnMoreStep: {
    modal: {
      Layout: EstatePlanningBuyLearnMoreStepLayout,
      metaOverrideSet: EstatePlanningBuyLearnMoreMetaOverride,
      modalType: 'legacy',
    },
  },
  EstatePlanInitializeIntroStep: {
    modal: {
      Layout: EstatePlanningInitializeIntroStepLayout,
      metaOverrideSet: EstatePlanningInitializeIntroMetaOverride,
      modalType: 'legacy',
    },
  },
  LinkApexFundingAccountStep: {
    modal: {
      Layout: ApexFundingAccountListStep,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  PlannerAccountApplicationWelcomeStep: {
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: true,
      modalType: 'legacy',
    },
  },
  dependent: {
    modal: {
      Layout: DependentLayout,
      metaOverrideSet: DependentMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  child: {
    modal: {
      Layout: DependentLayout,
      metaOverrideSet: DependentMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  SelectFileStepNoFullscreen: {
    modal: {
      Layout: SelectFileStepLayout,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  UploadOrSelectFromSecureFilesStepNoFullscreen: {
    modal: {
      Layout: UploadOrSelectFromSecureFilesStepLayout,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  UploadFileStepNoFullscreen: {
    modal: {
      Layout: UploadFileStepLayout,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  HouseholdAddress: {
    modal: {
      Layout: HouseholdAddressLayout,
      metaOverrideSet: HouseholdAddressOverrideSet,
    },
  },
  AppAnnouncement: {
    modal: {
      Layout: AppAnnouncementLayout,
      metaOverrideSet: AppAnnouncementOverrideSet,
    },
  },
  RequestChurnCancelStep: {
    modal: {
      Layout: WizardRefreshStepLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: false,
      modalType: 'legacy',
    },
  },
  RequestChurnCancelSuccessStep: {
    modal: {
      Layout: WizardCompleteLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: false,
      modalType: 'legacy',
    },
  },
  RequestChurnWithConcessionsIntroStep: {
    modal: {
      Layout: RequestChurnWithConcessionsIntroStepLayout,
      metaOverrideSet: RequestChurnWithConcessionsIntroStepOverrideSet,
      color: 'subtle',
      fixedHeight: false,
    },
  },
  RequestChurnWithConcessionsReasonsStep: {
    modal: {
      Layout: RequestChurnWithConcessionsReasonsStepLayout,
      metaOverrideSet: RequestChurnWithConcessionsReasonsStepOverrideSet,
      color: 'subtle',
      fixedHeight: false,
    },
  },
  RequestChurnWithConcessionsSelectionStep: {
    modal: {
      Layout: RequestChurnWithConcessionsSelectionStepLayout,
      metaOverrideSet: RequestChurnWithConcessionsSelectionStepOverrideSet,
      modalSize: MODAL_SIZE.md,
      color: 'subtle',
      fixedHeight: false,
    },
  },
  RequestChurnWithConcessionsAdditionalFeedbackStep: {
    modal: {
      Layout: RequestChurnWithConcessionsAdditionalFeedbackStepLayout,
      metaOverrideSet: RequestChurnWithConcessionsAdditionalFeedbackStepOverrideSet,
      color: 'subtle',
      fixedHeight: false,
    },
  },
  RequestChurnWithConcessionsCompleteStep: {
    modal: {
      Layout: RequestChurnWithConcessionsCompleteStepLayout,
      metaOverrideSet: RequestChurnWithConcessionsCompleteStepOverrideSet,
      fixedHeight: false,
      color: 'subtle',
    },
  },
  FacetPlanDetailsStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: defaultFDModalMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
    },
  },
  SelectAssetLiabilityTypeStep: {
    modal: {
      color: 'subtle',
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeOverride,
      fixedHeight: false,
    },
  },
  SelectAssetTypeStep: {
    modal: {
      color: 'subtle',
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeOverride,
      fixedHeight: false,
    },
  },
  SelectLiabilityTypeStep: {
    modal: {
      color: 'subtle',
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeOverride,
      fixedHeight: false,
    },
  },
  BalanceSheetEditAccountTypeStep: {
    modal: {
      color: 'subtle',
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeOverride,
      fixedHeight: false,
    },
  },
  BalanceSheetEditAccountTypeStepDO: {
    modal: {
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeDOOverride,
      fixedHeight: false,
    },
  },
  SelectAssetLiabilityTypeStepDO: {
    modal: {
      Layout: SelectAssetLiabilityTypeTemplate,
      metaOverrideSet: SelectAssetLiabilityTypeDOOverride,
      fixedHeight: false,
    },
  },
  MemberProfileVerificationFailedStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: defaultFDWizardStepMetaOverrideSet,
    },
  },
  KYCUpdateMailingAddressStep: {
    modal: {
      Layout: KycUpdateMailingAddressStep,
      metaOverrideSet: KycUpdateMailingAddressStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  SelectInstitutionStepDO: {
    modal: {
      Layout: SelectInstitutionStepTemplate,
      metaOverrideSet: SelectInstitutionStepOverride,
    },
  },
  FacetPlanVirtualAccountSelectInstitutionStep: {
    modal: {
      Layout: FacetPlanVirtualAccountSelectInstitutionStepTemplate,
      metaOverrideSet: FacetPlanVirtualAccountSelectInstitutionStepOverride,
    },
  },
  BalanceSheetEditAccountSelectInstitutionStepDO: {
    modal: {
      Layout: BalanceSheetEditAccountSelectInstitutionStepDOTemplate,
      metaOverrideSet: SelectInstitutionStepOverride,
    },
  },
  BalanceSheetEditAccountSelectInstitutionStep: {
    modal: {
      Layout: BalanceSheetEditAccountSelectInstitutionStepTemplate,
      metaOverrideSet: BalanceSheetEditAccountSelectInstitutionStepOverride,
      color: 'subtle',
    },
  },
  RetirementAgeHighestPriorityStep: {
    modal: {
      Layout: RetirementAgeGoalSeekPrioritiesStepLayout,
      modalSize: MODAL_SIZE.md,
      metaOverrideSet: RetirementAgeGoalSeekPriorityOverride,
    },
  },
  RetirementAgeResultsStep: {
    modal: {
      Layout: RetirementAgeGoalSeekResultsStepLayout,
      modalSize: MODAL_SIZE.md,
      metaOverrideSet: RetirementAgeGoalSeekViewResultsOverride,
    },
  },
  RetirementAgeFineTuneStep: {
    modal: {
      Layout: RetirementAgeGoalSeekFineTuneStepLayout,
      modalSize: MODAL_SIZE.md,
      metaOverrideSet: RetirementAgeGoalSeekFineTuneOverride,
    },
  },
  BalanceSheetBankAccountInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetEducationAccountInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetEmployerSponsoredPlanInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetFSAInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetHSAInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetLiabilityInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetMortgageInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetCreditCardInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetNonRetirementAccountInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  BalanceSheetPersonalRetirementAccountInfoStep: {
    modal: {
      color: 'subtle',
      Layout: BalanceSheetAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
    },
  },
  AddRealAssetTypeBusinessOwnershipStep: {
    modal: {
      color: 'subtle',
      Layout: RealAssetModalLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
    },
  },
  AddRealAssetTypePersonalAssetStep: {
    modal: {
      color: 'subtle',
      Layout: RealAssetModalLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
    },
  },
  AddRealAssetTypePropertyStep: {
    modal: {
      color: 'subtle',
      Layout: RealAssetModalLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
    },
  },
  AddRealAssetTypeVehicleStep: {
    modal: {
      color: 'subtle',
      Layout: RealAssetModalLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
    },
  },
  AddRealAssetTypePersonalAssetStepDO: {
    modal: {
      Layout: DigitalOnboardingRealAssetInfoTemplate,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  AddRealAssetTypeBusinessOwnershipStepDO: {
    modal: {
      Layout: DigitalOnboardingRealAssetInfoTemplate,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  AddRealAssetTypeVehicleStepDO: {
    modal: {
      Layout: DigitalOnboardingRealAssetInfoTemplate,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  realAssetDO: {
    modal: {
      Layout: DigitalOnboardingRealAssetInfoTemplate,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  AddRealAssetTypePropertyStepDO: {
    modal: {
      Layout: DigitalOnboardingRealAssetInfoTemplate,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  BalanceSheetBankAccountInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetEducationAccountInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetEmployerSponsoredPlanInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetFSAInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetHSAInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetLiabilityInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetMortgageInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetCreditCardInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetNonRetirementAccountInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetPersonalRetirementAccountInfoStepDO: {
    modal: {
      Layout: DigitalOnboardingAccountInfoTemplate,
      fixedHeight: false,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  RiskToleranceWelcomeStep: {
    modal: {
      Layout: RiskToleranceWelcomeStepLayout,
      metaOverrideSet: RiskToleranceWelcomeStepOverrideSet,
    },
  },
  AnalyzeYourExpensesStep: {
    modal: {
      Layout: AnalyzeYourExpenses,
      metaOverrideSet: AnalyzeYourExpensesOverride,
      modalSize: MODAL_SIZE.sm,
      fixedHeight: false,
    },
  },
  AnalyzeYourExpensesAnswerResultStep: {
    modal: {
      Layout: AnalyzeYourExpensesAnswerResultTemplate,
      metaOverrideSet: AnalyzeYourExpensesAnswerResultOverride,
      modalSize: MODAL_SIZE.sm,
      fixedHeight: false,
    },
  },
  SummarizeYourCommonExpensesStep: {
    modal: {
      Layout: SummarizeYourCommonExpensesLayout,
      metaOverrideSet: SummarizeYourCommonExpensesOverrides,
      fixedHeight: false,
    },
  },
  SummarizeTheRestOfYourSpendingIntroStep: {
    modal: {
      Layout: SummarizeTheRestOfYourSpendingIntroLayout,
      metaOverrideSet: SummarizeTheRestOfYourSpendingIntroOverrides,
      fixedHeight: false,
    },
  },
  SummarizeYourSpendingIntroStep: {
    modal: {
      Layout: SummarizeYourSpendingIntroLayout,
      metaOverrideSet: SummarizeYourSpendingIntroOverrides,
      fixedHeight: false,
    },
  },
  riskToleranceQuestionInvestingExperience: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionInvestingScenario: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionInvestingHistory: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionThinkingAboutInvesting: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionWithdrawal: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionInvestingExperienceV2: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionInvestmentKnowledge: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionHowIFeelAboutInvesting: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionLongTermInvestmentPhilosophy: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionSignificantInvestmentLossReaction: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  riskToleranceQuestionBiggestFinancialConcern: {
    modal: {
      Layout: RiskToleranceBigPicklistQuestionLayout,
      metaOverrideSet: RiskToleranceBigPicklistQuestionOverrideSet,
    },
  },
  HouseholdFoundationalValuesIntroStep: {
    modal: {
      Layout: HouseholdFoundationalValuesIntroLayout,
      metaOverrideSet: householdFoundationalValuesIntroMetaOverrideSet,
      fixedHeight: false,
    },
  },
  HouseholdFoundationalValuesYouGotThisStep: {
    modal: {
      Layout: HouseholdFoundationalValuesYouGotThisLayout,
      metaOverrideSet: householdFoundationalValuesYouGotThisMetaOverrideSet,
      fixedHeight: false,
    },
  },
  HouseholdFoundationalValuesHowDoYouFeelStep: {
    modal: {
      Layout: HouseholdFoundationalValuesHowDoYouFeelLayout,
      metaOverrideSet: householdFoundationalValuesHowDoYouFeelMetaOverrideSet,
      fixedHeight: false,
    },
  },
  HouseholdFoundationalValuesMoneyAndEmotionsStep: {
    modal: {
      Layout: HouseholdFoundationalValuesMoneyAndEmotionsLayout,
      metaOverrideSet: householdFoundationalValuesMoneyAndEmotionsMetaOverrideSet,
      fixedHeight: false,
    },
  },
  ManagedAccountModelUpdateRequestSubmittedStep: {
    modal: {
      Layout: WizardCompleteLayout,
      metaOverrideSet: WizardStepOverride,
      modalType: 'legacy',
    },
  },
  ManagedAccountModelUpdateRequestStep: {
    modal: {
      Layout: WizardStepLayout,
      metaOverrideSet: fr.metaOverride({ base: BaseOverrideNoHidden }).override({ hint: 'richtext' },
        {
          _component: () => Richtext,
        },
        {
          ordinal: 300,
        }).nameOverride(wizardHiddenFields, {
        hidden: true,
      }),
      forceFullScreen: false,
      modalType: 'legacy',
    },
  },
  FacetPlanOutcomeGoalCreateRecurringExpensesStep: {
    modal: {
      Layout: DetailListLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: false,
      modalType: 'legacy',
    },
  },
  ManagedAccountSelectStep: {
    modal: {
      Layout: DetailListLayout,
      metaOverrideSet: WizardStepOverride,
      forceFullScreen: false,
      modalType: 'legacy',
    },
  },
  BasicChart: {
    modal: {
      Layout: MoneyFlowDetailsLayout,
      metaOverrideSet: MoneyFlowDetailsOverrideSet,
      fixedHeight: false,
      modalSize: MODAL_SIZE.lg,
    },
  },
  FacetPlanVirtualAccountFundingInstructionsAccountDetailsStep: {
    modal: {
      Layout: FacetPlanVirtualAccountFundingInstructionsAccountDetailsStepLayout,
      metaOverrideSet: FacetPlanVirtualAccountFundingInstructionsAccountDetailsStepOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanVirtualAccountFundingInstructionsDetailsStep: {
    modal: {
      Layout: FacetPlanVirtualAccountFundingInstructionsFundingTypeStepLayout,
      metaOverrideSet: FacetPlanVirtualAccountFundingInstructionsFundingTypeStepOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanVirtualAccountFundingInstructionsFundingTypeStep: {
    modal: {
      Layout: FacetPlanVirtualAccountFundingInstructionsFundingTypeStepLayout,
      metaOverrideSet: FacetPlanVirtualAccountFundingInstructionsFundingTypeStepOverrideSet,
      modalType: 'legacy',
    },
  },
  RetirementCustomWithdrawalStartDateSetupStep: {
    modal: {
      Layout: FacetPlanRetirementCustomWithdrawalStrategyLayout,
      metaOverrideSet: FacetPlanRetirementCustomWithdrawalStrategyMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEducationInfoStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanEducationFundingStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanSelectMultipleVirtualAccountsGenericOutcomeStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FinancialStabilityQuestionnaireStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  EmergencyFundStrategyReviewStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanGeneralSavingsOutcomeTargetMetStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  DebtOutcomeSetupStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  RetirementOutcomeClientAssumptionsStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: RetirementOutcomeClientAssumptionsStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanOutcomeGoalBaseInfoStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: FacetPlanOutcomeGoalBaseInfoStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  SelectManualOrLinkStepDO: {
    modal: {
      Layout: SelectManualOrLinkStepLayout,
      metaOverrideSet: AddNewInstitutionMetaOverrideSet,
      closeOnBackdropClick: true,
      modalSize: 'lg',
      fixedHeight: false,
      color: 'subtle',
      forceNotFullScreen: true,
    },
  },
  BalanceSheetAccountTypeStep: {
    modal: {
      Layout: BalanceSheetAccountTypeLayout,
      metaOverrideSet: BalanceSheetAccountInfoOverride,
      color: 'subtle',
    },
  },
  BalanceSheetAccountTypeStepDO: {
    modal: {
      Layout: BalanceSheetAccountTypeDOLayout,
      metaOverrideSet: DigitalOnboardingAccountInfoOverride,
    },
  },
  BalanceSheetRealAssetTypeStepDO: {
    modal: {
      Layout: BalanceSheetRealAssetTypeDOLayout,
      metaOverrideSet: DigitalOnboardingRealAssetInfoOverride,
    },
  },
  BalanceSheetRealAssetTypeStep: {
    modal: {
      Layout: BalanceSheetRealAssetTypeLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
      color: 'subtle',
    },
  },
  FacetPlanOutcomeGoalCreateOneTimeExpensesStep: {
    modal: {
      Layout: withWhatIfNavigationAndHeader(FacetPlanOutcomeGoalOneTimeExpense),
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanView: {
    modal: {
      Layout: NavigateToPage,
      modalType: 'legacy',
    },
  },
  FacetPlanProposalPreview: {
    modal: {
      Layout: NavigateToPage,
      modalType: 'legacy',
    },
  },
  PropertyOutcomeStrategySelectionStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: PropertyOutcomeStrategySelectionStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  PropertyOutcomeSellStrategyPropertyDetailsStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: FacetPlanChooseStartEndDateStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  PropertyOutcomeBuyStrategyPropertyDetailsStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: FacetPlanChooseStartEndDateStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  PropertyOutcomeBuyStrategyAccountAllocationStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: PropertyOutcomeBuyStrategyAccountAllocationStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  ProposalExpiration: {
    modal: {
      Layout: ProposalExpirationLayout,
      modalSize: MODAL_SIZE.md,
      noCloseButton: true,
      modalType: 'celebration',
      fixedHeight: false,
    },
  },
  PropertyBuyStrategyPropertyClosingCostsStep: {
    modal: {
      Layout: PropertyBuyStrategyPropertyClosingCostsStepLayout,
      metaOverrideSet: DefaultStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  PropertyBuyStrategyResetClosingCostsStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: propertyResetClosingCostsStepMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  ManagedAccountNickname: {
    modal: {
      Layout: EditManagedAccountNickname,
      modalSize: MODAL_SIZE.sm,
      metaOverrideSet: EditManagedAccountNicknameOverrideSet,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  FacetPlanProposalNextUpReview: {
    modal: {
      Layout: FacetPlanProposalNextUpReviewLayout,
      modalSize: MODAL_SIZE.lg,
      metaOverrideSet: facetPlanProposalNextUpReviewMetaOverrideSet,
      disableBackdropClickClosure: true,
      modalType: 'legacy',
    },
  },
  RolloverTransferQuestionnaireStepNew: {
    modal: {
      Layout: DolQuestionnaireModalTemplate,
      metaOverrideSet: dolMetaOverride,
      modalType: 'legacy',
    },
  },
  MemberActionItemResource: {
    modal: {
      Layout: MemberActionItemLayout,
      metaOverrideSet: MemberActionItemOverride,
      fixedHeight: false,
    },
  },
  ScenarioAcceptanceIntroStep: {
    modal: {
      Layout: ScenarioAcceptanceIntroStepLayout,
      metaOverrideSet: ScenarioAcceptanceIntroStepOverride,
    },
  },
  ScenarioAcceptanceWhyStep: {
    modal: {
      Layout: InformationalLayout,
    },
  },
  ScenarioAcceptanceCompletedStep: {
    modal: {
      Layout: InformationalLayout,
    },
  },
  ScenarioSelectionModelDetailsStep: {
    modal: {
      Layout: ScenarioSelectionModelDetailsStepTemplate,
      modalType: 'takeover',
      color: 'subtle',
    },
  },
  InvestorProfileAdditionalInfo: {
    modal: {
      Layout: InvestorProfileAdditionalInfoLayout,
    },
  },
  ScenarioAcceptanceHowToStep: {
    modal: {
      Layout: ScenarioAcceptanceHowToStepLayout,
      metaOverrideSet: ScenarioAcceptanceHowToStepOverride,
    },
  },
  ScenarioAcceptanceConfirmStep: {
    modal: {
      Layout: ScenarioAcceptanceConfirmStepLayout,
      metaOverrideSet: ScenarioAcceptanceConfirmStepOverride,
      modalType: 'celebration',
    },
  },
  AccountSummary: {
    modal: {
      Layout: AccountSummaryLayout,
      metaOverrideSet: AccountSummaryOverride,
    },
  },
  householdExpenseCategoryIntroPX: {
    modal: {
      Layout: CashFlowPageExpenseIntroLayout,
      metaOverrideSet: CashFlowPageExpenseIntroOverrideSet,
      modalType: 'legacy',
    },
  },
  householdExpenseCategory: {
    modal: {
      fixedHeight: false,
      Layout: CashFlowPageExpenseLayout,
      metaOverrideSet: CashFlowPageExpenseOverrideSet,
    },
  },
  householdExpenseCategoryPX: {
    modal: {
      fixedHeight: false,
      Layout: CashFlowPageExpenseLayout,
      metaOverrideSet: CashFlowPageExpenseOverrideSet,
    },
  },
  AddExpensePXStep: {
    modal: {
      fixedHeight: false,
      Layout: CashFlowPageExpenseLayout,
      metaOverrideSet: CashFlowPageExpenseOverrideSet,
    },
  },
  MonthAheadInCheckingStep: {
    modal: {
      fixedHeight: false,
      Layout: CreditScoreLayout,
      metaOverrideSet: CreditScoreOverrideSet,
    },
  },
  FullEmergencyFundStep: {
    modal: {
      fixedHeight: false,
      Layout: CreditScoreLayout,
      metaOverrideSet: CreditScoreOverrideSet,
    },
  },
  MoneyMindsetArticleStep: {
    modal: {
      fixedHeight: false,
      Layout: CreditScoreLayout,
      metaOverrideSet: CreditScoreOverrideSet,
    },
  },
  ReviewCreditReportStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  ReviewCreditReportIntroStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  ReviewCreditReportLiftExistingFreezesStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  ReviewCreditReportRequestReportStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  ReviewCreditReportReviewReportStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  ReviewCreditReportPlaceFreezeStep: {
    modal: {
      fixedHeight: false,
      Layout: ReviewCreditReportStepLayout,
      metaOverrideSet: reviewCreditReportStepOverrideSet,
    },
  },
  IncreaseCreditScoreStep: {
    modal: {
      fixedHeight: false,
      Layout: CreditScoreLayout,
      metaOverrideSet: CreditScoreOverrideSet,
    },
  },
  WorkOnIncreasingCreditScoreStep: {
    modal: {
      fixedHeight: false,
      Layout: CreditScoreLayout,
      metaOverrideSet: CreditScoreOverrideSet,
    },
  },
  ReviewCreditReportSkipStep: {
    modal: {
      Layout: CreditScoreSkipLayout,
      metaOverrideSet: defaultFDWizardStepMetaOverrideSet,
    },
  },
  CreateYourPlanCompletedStep: {
    modal: {
      fixedHeight: false,
      Layout: PageCompletionSummaryLayout,
      metaOverrideSet: PageCompletionSummaryOverride,
    },
  },
  PageCompletionSummaryStep: {
    modal: {
      fixedHeight: false,
      Layout: PageCompletionSummaryLayout,
      metaOverrideSet: PageCompletionSummaryOverride,
    },
  },
  OptimalDebtPathStep: {
    modal: {
      Layout: OptimalDebtPathStepLayout,
      metaOverrideSet: optimalDebtPathStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
      fixedHeight: false,
    },
  },
  OptimalDebtPathLiabilitiesStep: {
    modal: {
      Layout: OptimalDebtPathLiabilitiesStepLayout,
      metaOverrideSet: optimalDebtPathLiabilitiesStepOverrideSet,
      modalSize: MODAL_SIZE.sm,
    },
  },
  BulkExpenseReducibilityAdjustmentStep: {
    modal: {
      Layout: BulkExpenseReducibilityAdjustmentStepLayout,
      metaOverrideSet: bulkExpenseReducibilityAdjustmentStepOverrideSet,
      fixedHeight: false,
    },
  },
  ExpensesReducibleByStepStep: {
    modal: {
      Layout: ExpensesReducibleByStepLayout,
      metaOverrideSet: ExpensesReducibleByStepOverrideSet,
    },
  },
  JobIntroStep: {
    modal: {
      Layout: JobIntroStepLayout,
      metaOverrideSet: JobIntroStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEditNavigationStep: {
    modal: {
      Layout: JobEditNavigationStepLayout,
      metaOverrideSet: jobEditNavigationStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobBasicInformationStep: {
    modal: {
      Layout: JobBasicInformationStepLayout,
      metaOverrideSet: JobBasicInformationStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobDeductionsStep: {
    modal: {
      Layout: JobDeductionsStepLayout,
      metaOverrideSet: JobDeductionsStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobAdditionalIncomeDetailStep: {
    modal: {
      Layout: JobAdditionalIncomeDetailStepLayout,
      metaOverrideSet: JobAdditionalIncomeDetailStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchElectiveSetupStep: {
    modal: {
      Layout: JobEmployerMatchElectiveSetupStepLayout,
      metaOverrideSet: espMatchElectiveStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchNonElectiveSetupStep: {
    modal: {
      Layout: JobEmployerMatchNonElectiveSetupStepLayout,
      metaOverrideSet: JobEmployerMatchNonElectiveSetupStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchNonElectiveDecisionStep: {
    modal: {
      Layout: JobEmployerMatchDecisionStepLayout,
      metaOverrideSet: JobEmployerMatchDecisionStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchElectiveDecisionStep: {
    modal: {
      Layout: JobEmployerMatchDecisionStepLayout,
      metaOverrideSet: JobEmployerMatchDecisionStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchNoAccountStep: {
    modal: {
      Layout: JobEmployerMatchNoAccountStepLayout,
      metaOverrideSet: JobEmployerMatchNoAccountStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobEmployerMatchWrongAccountTypeStep: {
    modal: {
      Layout: JobEmployerMatchWrongAccountTypeLayout,
      metaOverrideSet: JobEmployerMatchWrongAccountTypeMetaOverrideSet,
      fixedHeight: false,
    },
  },
  JobAdditionalIncomeListStep: {
    modal: {
      Layout: JobAdditionalIncomeListStepLayout,
      metaOverrideSet: JobAdditionalIncomeListStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  IncomeDetail: {
    modal: {
      Layout: IncomeDetailsLayout,
      metaOverrideSet: IncomeDetailsOverrideSet,
    },
  },
  GuidedHouseholdReviewSetAdjustmentExpenseStep: {
    modal: {
      Layout: GuidedHouseholdReviewSetAdjustmentExpenseLayout,
      metaOverrideSet: GuidedHouseholdReviewSetAdjustmentExpenseOverrideSet,
      modalSize: MODAL_SIZE.xs,
      fixedHeight: false,
    },
  },
  IncomeDetailStep: {
    modal: {
      Layout: IncomeDetailsStepLayout,
      metaOverrideSet: IncomeDetailsStepOverrideSet,
    },
  },
  Account: {
    modal: {
      Layout: EditAccountLayout,
      color: 'subtle',
      metaOverrideSet: editAccountMetaOverrideSet,
    },
  },
  ManageFacetPlanMoneyMovementDetailsStep: {
    modal: {
      Layout: ManageFacetPlanMoneyMovementDetailsStepLayout,
      metaOverrideSet: facetPlanMoneyMovementMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  ManageFacetPlanMoneyMovementAUMDeleteStepStep: {
    modal: {
      Layout: DefaultStepLayout,
      metaOverrideSet: facetPlanMoneyMovementMetaOverrideSet,
      modalType: 'legacy',
    },
  },
  IncomeTypeStep: {
    modal: {
      Layout: IncomeTypeStepLayout,
      metaOverrideSet: incomeTypeStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  realAsset: {
    modal: {
      color: 'subtle',
      Layout: RealAssetModalLayout,
      metaOverrideSet: realAssetMetaOverrideSet,
    },
  },
  FundingAccountReauthenticationIntroStep: {
    modal: {
      Layout: FundingAccountReauthenticationIntroLayout,
      metaOverrideSet: FundingAccountReauthenticationIntroOverride,
    },
  },
  FundingAccountRelinkStep: {
    modal: {
      Layout: FundingAccountRelinkIntroLayout,
      metaOverrideSet: FundingAccountRelinkIntroOverride,
    },
  },
  CreateYourPlanGetStartedStep: {
    modal: {
      Layout: CreateYourPlanTextLayout,
      metaOverrideSet: CreateYourPlanTextMetaOverrides,
    },
  },
  CreateYourPlanConfirmationStep: {
    modal: {
      Layout: CreateYourPlanConfirmationStepLayout,
      metaOverrideSet: CreateYourPlanConfirmationStepMetaOverrides,
    },
  },
  CreateYourPlanReviewStep: {
    modal: {
      Layout: CreateYourPlanReviewStepLayout,
      metaOverrideSet: CreateYourPlanReviewMetaOverrideSet,
    },
  },
  ConciergeTransaction: {
    modal: {
      Layout: ConciergeTransactionTemplate,
      metaOverrideSet: MetaOverrideSet,
      closeOnBackdropClick: true,
      fixedHeight: false,
      color: 'subtle',
    },
  },
  FacetPlanJob: {
    modal: {
      Layout: DefaultFDModalLayout,
      metaOverrideSet: defaultFDModalMetaOverrideSet,
    },
  },
  DesiredOutcomesMemberDataCaptureRetirement: {
    modal: {
      Layout: DesiredOutcomeDetails,
      metaOverrideSet: DesiredOutcomeDetailsOverrideSet,
      modalType: 'legacy',
    },
  },
  DesiredOutcomesMemberDataCaptureGeneralSavings: {
    modal: {
      Layout: DesiredOutcomeDetails,
      metaOverrideSet: DesiredOutcomeDetailsOverrideSet,
      modalType: 'legacy',
    },
  },
  DesiredOutcomesMemberDataCaptureEducation: {
    modal: {
      Layout: DesiredOutcomeDetails,
      metaOverrideSet: DesiredOutcomeDetailsOverrideSet,
      modalType: 'legacy',
    },
  },
  DesiredOutcomesMemberDataCapturePropertyBuy: {
    modal: {
      Layout: DesiredOutcomeDetails,
      metaOverrideSet: DesiredOutcomeDetailsOverrideSet,
      modalType: 'legacy',
    },
  },
  DesiredOutcomesMemberDataCapturePropertySell: {
    modal: {
      Layout: DesiredOutcomeDetails,
      metaOverrideSet: DesiredOutcomeDetailsOverrideSet,
      modalType: 'legacy',
    },
  },
  FacetPlanAutomationVariant: {
    modal: {
      Layout: DefaultFDModalLayout,
      metaOverrideSet: defaultFDModalMetaOverrideSet,
    },
  },
  FacetPlanRetirementWithdrawal: {
    modal: {
      Layout: FacetPlanRetirementWithdrawalLayout,
      metaOverrideSet: FacetPlanRetirementWithdrawalMetaOverrideSet,
      modalType: 'takeover',
    },
  },
  RoadmapExplorerManagePaths: {
    modal: {
      Layout: RoadmapExplorerManagePathsLayout,
      metaOverrideSet: defaultFDModalMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      fixedHeight: false,
    },
  },
  ScenarioSelectionAssumptionAndDetail: {
    modal: {
      Layout: ScenarioSelectionAssumptionsAndDetails,
      metaOverrideSet: ScenarioSelectionAssumptionsAndDetailsMetaOverrideSet,
      modalType: 'takeover',
      padding: false,
    },
  },
  ScenarioAssumption: {
    modal: {
      Layout: ScenarioAssumption,
      metaOverrideSet: ScenarioAssumptionMetaOverrideSet,
      modalType: 'takeover',
      padding: false,
    },
  },
  AdditionalDetail: {
    modal: {
      Layout: AdditionalDetailsLayout,
      metaOverrideSet: AdditionalDetailsMetaOverrideSet,
      modalType: 'takeover',
    },
  },
  FacetPlanVirtualAccountEditInformationStep: {
    modal: {
      Layout: FacetPlanVirtualAccountEditInformationStepLayout,
      metaOverrideSet: FacetPlanVirtualAccountEditInformationStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  ManageFacetPlanRealAssetDetailsStep: {
    modal: {
      Layout: ManageFacetPlanRealAssetDetailsStepLayout,
      metaOverrideSet: ManageFacetPlanRealAssetDetailsStepMetaOverrideSet,
      fixedHeight: false,
    },
  },
  FacetPlanCustomStrategySetupInfoStep: {
    modal: {
      Layout: FacetPlanCustomStrategySetupInfoStepLayout,
      metaOverrideSet: FacetPlanCustomStrategySetupInfoStepMetaOverrideSet,
      modalSize: MODAL_SIZE.lg,
      fixedHeight: true,
      color: 'subtle',
    },
  },
  SelectOutcomesStep: {
    modal: {
      Layout: SelectOutcomesStepTemplate,
      metaOverrideSet: SelectOutcomeStepMetaOverride,
      fixedHeight: false,
    },
  },
  DeliverableIntroductionIntroStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableGaugesInfoStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableChartInfoStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableInvestmentsInfoStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableYearAheadInfoStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableDiscussionTopicsInfoStep: {
    modal: {
      Layout: DeliverableIntroductionWizardStepLayout,
      metaOverrideSet: DeliverableIntroductionWizardStepMetaOverride,
      closeOnBackdropClick: false,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  DeliverableIntroductionCompleteStep: {
    modal: {
      Layout: NoopFinishStep,
    },
  },
  SaveForRetirementStep: {
    modal: {
      Layout: SaveForRetirementLayout,
      metaOverrideSet: SaveForRetirementOverride,
      fixedHeight: false,
    },
  },
  PayOffDebtStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: GoalDetailStepMetaOverride,
      fixedHeight: false,
    },
  },
  SaveForEducationStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: GoalDetailStepMetaOverride,
      fixedHeight: false,
    },
  },
  BuyApropertyStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: GoalDetailStepMetaOverride,
      fixedHeight: false,
    },
  },
  SellApropertyStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: GoalDetailStepMetaOverride,
      fixedHeight: false,
    },
  },
  CustomGoalStep: {
    modal: {
      Layout: DefaultFDWizardStepLayout,
      metaOverrideSet: GoalDetailStepMetaOverride,
      fixedHeight: false,
    },
  },
  FQTmplQuiz: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplQuiz'),
      fixedHeight: false,
    },
  },
  FQTmplSection: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplSection'),
      fixedHeight: false,
    },
  },
  FQTmplInsight: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplInsight'),
      fixedHeight: false,
    },
  },
  FQTmplQuestion: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplQuestion'),
      fixedHeight: false,
    },
  },
  FQTmplCondition: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplCondition'),
      fixedHeight: false,
    },
  },
  FQTmplPaymentPage: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplPaymentPage'),
      fixedHeight: false,
    },
  },
  FQTmplContactForm: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplContactForm'),
      fixedHeight: false,
    },
  },
  Experiment: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('Experiment'),
      fixedHeight: false,
    },
  },
  FQTmplCompletedScreen: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplCompletedScreen'),
      fixedHeight: false,
    },
  },
  FQTmplBanner: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQTmplBanner'),
      fixedHeight: false,
    },
  },
  FQRouteWhitelist: {
    modal: {
      Layout: CondensedCrudFormTemplate,
      metaOverrideSet: getCondensedCrudFormTemplateMetaOverrideSet('FQRouteWhitelist'),
      fixedHeight: false,
    },
  },
  InvestmentApproach: {
    modal: {
      Layout: InvestmentApproachesLayout,
      metaOverrideSet: InvestmentApproachesMetaOverrideSet,
      modalType: 'takeover',
      padding: false,
    },
  },
  TaxDashboardReviewKickoffQuestionsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffFilingStatusStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffStatesStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffOutroStep: {
    modal: {
      Layout: TaxDashboardWizardLottieLayout,
      metaOverrideSet: taxDashboardWizardLottieLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardAskAnExpert: {
    modal: {
      Layout: TaxDashboardAskAnExpertLayout,
      metaOverrideSet: taxDashboardAskAnExpertMetaOverrideSet,
      modalSize: MODAL_SIZE.sm,
      noCloseButton: true,
      fixedHeight: false,
    },
  },
  TaxDashboardReviewKickoffIntroStep: {
    modal: {
      Layout: TaxDashboardWizardTimelineLayout,
      metaOverrideSet: taxDashboardWizardTimelineLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffSituationStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffUploadStep: {
    modal: {
      Layout: TaxDashboardWizardUploadLayout,
      metaOverrideSet: taxDashboardWizardUploadLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffFilingMethodStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardReviewKickoffExternalFilingMethodStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesIntroStep: {
    modal: {
      Layout: TaxDashboardWizardTimelineLayout,
      metaOverrideSet: taxDashboardWizardTimelineLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRetirementAccountsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRetirementAccountsRoadmapStep: {
    modal: {
      Layout: TaxDashboardWizardAccountsLayout,
      metaOverrideSet: taxDashboardWizardAccountsLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRetirementContributionsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesHsaAccountsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesHsaAccountsRoadmapStep: {
    modal: {
      Layout: TaxDashboardWizardAccountsLayout,
      metaOverrideSet: taxDashboardWizardAccountsLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesHsaContributionsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesInvestmentsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesInvestmentsFacetStep: {
    modal: {
      Layout: TaxDashboardWizardInvestmentGainsLossesLayout,
      metaOverrideSet: taxDashboardWizardInvestmentGainsLossesLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRmdIntroStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRmdFacetStep: {
    modal: {
      Layout: TaxDashboardWizardLottieLayout,
      metaOverrideSet: taxDashboardWizardLottieLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesRmdExternalStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesGivingStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesTaxPaymentsStep: {
    modal: {
      Layout: TaxDashboardWizardQuestionLayout,
      metaOverrideSet: taxDashboardWizardQuestionLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
  TaxDashboardCurrentYearOpportunitiesOutroStep: {
    modal: {
      Layout: TaxDashboardWizardLottieLayout,
      metaOverrideSet: taxDashboardWizardLottieLayoutMetaOverrideSet,
      ...taxDashboardWizardModalProps,
    },
  },
};
